var ActionStatus;
(function (ActionStatus) {
    ActionStatus["Failure"] = "FAILURE";
    ActionStatus["Success"] = "SUCCESS";
})(ActionStatus || (ActionStatus = {}));
var AdcAssignedSigner;
(function (AdcAssignedSigner) {
    AdcAssignedSigner["BackupSigner"] = "BACKUP_SIGNER";
    AdcAssignedSigner["Original"] = "ORIGINAL";
})(AdcAssignedSigner || (AdcAssignedSigner = {}));
var AssetType;
(function (AssetType) {
    AssetType["BankOwned"] = "BANK_OWNED";
    AssetType["Foreclosure"] = "FORECLOSURE";
    AssetType["PrivateSeller"] = "PRIVATE_SELLER";
    AssetType["Rentals"] = "RENTALS";
    AssetType["ShortSale"] = "SHORT_SALE";
})(AssetType || (AssetType = {}));
var AttorneyCompanyType;
(function (AttorneyCompanyType) {
    AttorneyCompanyType["Attorney"] = "ATTORNEY";
})(AttorneyCompanyType || (AttorneyCompanyType = {}));
var AttorneyLeadStatus;
(function (AttorneyLeadStatus) {
    AttorneyLeadStatus["AuctionInProgress"] = "AUCTION_IN_PROGRESS";
    AttorneyLeadStatus["Cancelled"] = "CANCELLED";
    AttorneyLeadStatus["ClearedForSales"] = "CLEARED_FOR_SALES";
    AttorneyLeadStatus["Ineligible"] = "INELIGIBLE";
    AttorneyLeadStatus["PendingAuction"] = "PENDING_AUCTION";
    AttorneyLeadStatus["PendingResult"] = "PENDING_RESULT";
    AttorneyLeadStatus["Postponed"] = "POSTPONED";
    AttorneyLeadStatus["Returned"] = "RETURNED";
    AttorneyLeadStatus["RevertToBeneficiary"] = "REVERT_TO_BENEFICIARY";
    AttorneyLeadStatus["SaleFailed"] = "SALE_FAILED";
    AttorneyLeadStatus["SoldToThirdParty"] = "SOLD_TO_THIRD_PARTY";
    AttorneyLeadStatus["Unscheduled"] = "UNSCHEDULED";
})(AttorneyLeadStatus || (AttorneyLeadStatus = {}));
var AttributionSourceType;
(function (AttributionSourceType) {
    AttributionSourceType["AuctionCom"] = "AUCTION_COM";
    AttributionSourceType["SparkOffer"] = "SPARK_OFFER";
})(AttributionSourceType || (AttributionSourceType = {}));
var AuctionSegmentStatus;
(function (AuctionSegmentStatus) {
    AuctionSegmentStatus["Aborted"] = "ABORTED";
    AuctionSegmentStatus["Ended"] = "ENDED";
    AuctionSegmentStatus["Extended"] = "EXTENDED";
    AuctionSegmentStatus["Started"] = "STARTED";
    AuctionSegmentStatus["Unset"] = "UNSET";
})(AuctionSegmentStatus || (AuctionSegmentStatus = {}));
var AuctionStatus;
(function (AuctionStatus) {
    AuctionStatus["Canceled"] = "CANCELED";
    AuctionStatus["Closed"] = "CLOSED";
    AuctionStatus["InClosing"] = "IN_CLOSING";
    AuctionStatus["NoSale"] = "NO_SALE";
    AuctionStatus["OutbidPeriod"] = "OUTBID_PERIOD";
    AuctionStatus["PendingScheduling"] = "PENDING_SCHEDULING";
    AuctionStatus["Postponed"] = "POSTPONED";
    AuctionStatus["Removed"] = "REMOVED";
    AuctionStatus["SaleFailed"] = "SALE_FAILED";
    AuctionStatus["SaleGatekeeping"] = "SALE_GATEKEEPING";
    AuctionStatus["SalePending"] = "SALE_PENDING";
    AuctionStatus["SalePendingCleared"] = "SALE_PENDING_CLEARED";
    AuctionStatus["Withdrawn"] = "WITHDRAWN";
})(AuctionStatus || (AuctionStatus = {}));
var AuctionType;
(function (AuctionType) {
    AuctionType["Live"] = "LIVE";
    AuctionType["Online"] = "ONLINE";
})(AuctionType || (AuctionType = {}));
var BidSource;
(function (BidSource) {
    BidSource["Servicer"] = "SERVICER";
    BidSource["Trustee"] = "TRUSTEE";
    BidSource["WebService"] = "WEB_SERVICE";
})(BidSource || (BidSource = {}));
var BidType;
(function (BidType) {
    BidType["HighLow"] = "HIGH_LOW";
    BidType["Redemption"] = "REDEMPTION";
    BidType["Specified"] = "SPECIFIED";
    BidType["TotalDebt"] = "TOTAL_DEBT";
})(BidType || (BidType = {}));
var BidderRegistrationSignupSource;
(function (BidderRegistrationSignupSource) {
    BidderRegistrationSignupSource["Adc"] = "ADC";
    BidderRegistrationSignupSource["AndroidNative"] = "ANDROID_NATIVE";
    BidderRegistrationSignupSource["Auctionsync"] = "AUCTIONSYNC";
    BidderRegistrationSignupSource["AuctionsyncQr"] = "AUCTIONSYNC_QR";
    BidderRegistrationSignupSource["IosNative"] = "IOS_NATIVE";
    BidderRegistrationSignupSource["Mlh"] = "MLH";
    BidderRegistrationSignupSource["Morpheus"] = "MORPHEUS";
    BidderRegistrationSignupSource["Test"] = "TEST";
})(BidderRegistrationSignupSource || (BidderRegistrationSignupSource = {}));
var BidderType;
(function (BidderType) {
    BidderType["Live"] = "LIVE";
    BidderType["Online"] = "ONLINE";
    BidderType["ProxyBidder"] = "PROXY_BIDDER";
    BidderType["Upset"] = "UPSET";
})(BidderType || (BidderType = {}));
var BidderUserType;
(function (BidderUserType) {
    BidderUserType["PartialUser"] = "PARTIAL_USER";
    BidderUserType["User"] = "USER";
})(BidderUserType || (BidderUserType = {}));
var BidderVerificationType;
(function (BidderVerificationType) {
    BidderVerificationType["DriverLicense"] = "DRIVER_LICENSE";
    BidderVerificationType["Other"] = "OTHER";
    BidderVerificationType["Passport"] = "PASSPORT";
})(BidderVerificationType || (BidderVerificationType = {}));
var BidsAwayStatus;
(function (BidsAwayStatus) {
    BidsAwayStatus["None"] = "NONE";
    BidsAwayStatus["OneAway"] = "ONE_AWAY";
    BidsAwayStatus["OneAwayDisplayed"] = "ONE_AWAY_DISPLAYED";
    BidsAwayStatus["TwoAway"] = "TWO_AWAY";
    BidsAwayStatus["TwoAwayDisplayed"] = "TWO_AWAY_DISPLAYED";
})(BidsAwayStatus || (BidsAwayStatus = {}));
var BuyerPath;
(function (BuyerPath) {
    BuyerPath["MakeAnOffer"] = "MAKE_AN_OFFER";
    BuyerPath["ProxyBid"] = "PROXY_BID";
})(BuyerPath || (BuyerPath = {}));
var BuyerPaymentType;
(function (BuyerPaymentType) {
    BuyerPaymentType["LiveRemoteBidding"] = "LIVE_REMOTE_BIDDING";
    BuyerPaymentType["OnlineBidDeposit"] = "ONLINE_BID_DEPOSIT";
})(BuyerPaymentType || (BuyerPaymentType = {}));
var CancelPrimaryReason;
(function (CancelPrimaryReason) {
    CancelPrimaryReason["Bankruptcy"] = "BANKRUPTCY";
    CancelPrimaryReason["BeneficiaryRequest"] = "BENEFICIARY_REQUEST";
    CancelPrimaryReason["CourtOrder"] = "COURT_ORDER";
    CancelPrimaryReason["LoanModification"] = "LOAN_MODIFICATION";
    CancelPrimaryReason["LossMitigation"] = "LOSS_MITIGATION";
    CancelPrimaryReason["MutualAgreement"] = "MUTUAL_AGREEMENT";
    CancelPrimaryReason["NaturalDisaster"] = "NATURAL_DISASTER";
    CancelPrimaryReason["Other"] = "OTHER";
    CancelPrimaryReason["Payoff"] = "PAYOFF";
    CancelPrimaryReason["PendingDetails"] = "PENDING_DETAILS";
    CancelPrimaryReason["ReceivedNewDate"] = "RECEIVED_NEW_DATE";
    CancelPrimaryReason["Reinstatement"] = "REINSTATEMENT";
    CancelPrimaryReason["TrusteeDiscretion"] = "TRUSTEE_DISCRETION";
})(CancelPrimaryReason || (CancelPrimaryReason = {}));
var CertificateQualityControlStatus;
(function (CertificateQualityControlStatus) {
    CertificateQualityControlStatus["Approved"] = "APPROVED";
    CertificateQualityControlStatus["Disapproved"] = "DISAPPROVED";
    CertificateQualityControlStatus["NoReview"] = "NO_REVIEW";
})(CertificateQualityControlStatus || (CertificateQualityControlStatus = {}));
var CertificateType;
(function (CertificateType) {
    CertificateType["CanceledCertificate"] = "CANCELED_CERTIFICATE";
    CertificateType["ContractPackage"] = "CONTRACT_PACKAGE";
    CertificateType["PostponementCertificate"] = "POSTPONEMENT_CERTIFICATE";
    CertificateType["RevertCertificate"] = "REVERT_CERTIFICATE";
    CertificateType["SaleFailedCertificate"] = "SALE_FAILED_CERTIFICATE";
})(CertificateType || (CertificateType = {}));
var ChargeReason;
(function (ChargeReason) {
    ChargeReason["AutoFallout"] = "AUTO_FALLOUT";
    ChargeReason["BankCannotProcess"] = "BANK_CANNOT_PROCESS";
    ChargeReason["CheckReturned"] = "CHECK_RETURNED";
    ChargeReason["CreditNotProcessed"] = "CREDIT_NOT_PROCESSED";
    ChargeReason["CustomerInitiated"] = "CUSTOMER_INITIATED";
    ChargeReason["DebitNotAuthorized"] = "DEBIT_NOT_AUTHORIZED";
    ChargeReason["Duplicate"] = "DUPLICATE";
    ChargeReason["Fraudulent"] = "FRAUDULENT";
    ChargeReason["General"] = "GENERAL";
    ChargeReason["IncorrectAccountDetails"] = "INCORRECT_ACCOUNT_DETAILS";
    ChargeReason["InsufficientFunds"] = "INSUFFICIENT_FUNDS";
    ChargeReason["ManualFallout"] = "MANUAL_FALLOUT";
    ChargeReason["ProductNotReceived"] = "PRODUCT_NOT_RECEIVED";
    ChargeReason["ProductUnacceptable"] = "PRODUCT_UNACCEPTABLE";
    ChargeReason["Sale"] = "SALE";
    ChargeReason["SubscriptionCanceled"] = "SUBSCRIPTION_CANCELED";
    ChargeReason["Unrecognized"] = "UNRECOGNIZED";
})(ChargeReason || (ChargeReason = {}));
var ClosingCancellationReason;
(function (ClosingCancellationReason) {
    ClosingCancellationReason["BuyerNonPerformance"] = "BUYER_NON_PERFORMANCE";
    ClosingCancellationReason["BuyerRemorse"] = "BUYER_REMORSE";
    ClosingCancellationReason["BuyerRemorseTermsOfLease"] = "BUYER_REMORSE_TERMS_OF_LEASE";
    ClosingCancellationReason["BuyerTermination"] = "BUYER_TERMINATION";
    ClosingCancellationReason["CityInspectionFailed"] = "CITY_INSPECTION_FAILED";
    ClosingCancellationReason["CloserEscrowDelay"] = "CLOSER_ESCROW_DELAY";
    ClosingCancellationReason["DelayOfEscrow"] = "DELAY_OF_ESCROW";
    ClosingCancellationReason["EmdNotDeposited"] = "EMD_NOT_DEPOSITED";
    ClosingCancellationReason["EscrowCoDelay"] = "ESCROW_CO_DELAY";
    ClosingCancellationReason["FalloutMlh"] = "FALLOUT_MLH";
    ClosingCancellationReason["FalloutMorpheus"] = "FALLOUT_MORPHEUS";
    ClosingCancellationReason["FinancingFailed"] = "FINANCING_FAILED";
    ClosingCancellationReason["FundsToClose"] = "FUNDS_TO_CLOSE";
    ClosingCancellationReason["Invalid"] = "INVALID";
    ClosingCancellationReason["NaturalDisaster"] = "NATURAL_DISASTER";
    ClosingCancellationReason["NegotiatorDelayApprovalLetter"] = "NEGOTIATOR_DELAY_APPROVAL_LETTER";
    ClosingCancellationReason["OnlineContractNotFinalized"] = "ONLINE_CONTRACT_NOT_FINALIZED";
    ClosingCancellationReason["PropertyIssues"] = "PROPERTY_ISSUES";
    ClosingCancellationReason["RentalsBuyerFinancingFailed"] = "RENTALS_BUYER_FINANCING_FAILED";
    ClosingCancellationReason["RentalsLeaseAgreementNotAssignable"] = "RENTALS_LEASE_AGREEMENT_NOT_ASSIGNABLE";
    ClosingCancellationReason["RentalsLenderAppraisalIssue"] = "RENTALS_LENDER_APPRAISAL_ISSUE";
    ClosingCancellationReason["RentalsTenantUncooperative"] = "RENTALS_TENANT_UNCOOPERATIVE";
    ClosingCancellationReason["SellerDelayExecutionOfDocuments"] = "SELLER_DELAY_EXECUTION_OF_DOCUMENTS";
    ClosingCancellationReason["SellerDelayForeclosureDeedNotRecorded"] = "SELLER_DELAY_FORECLOSURE_DEED_NOT_RECORDED";
    ClosingCancellationReason["SellerDelayNoResponseToSubjectTo"] = "SELLER_DELAY_NO_RESPONSE_TO_SUBJECT_TO";
    ClosingCancellationReason["SellerDelayUnableToPerform"] = "SELLER_DELAY_UNABLE_TO_PERFORM";
    ClosingCancellationReason["SellerRejected"] = "SELLER_REJECTED";
    ClosingCancellationReason["SellerTermination"] = "SELLER_TERMINATION";
    ClosingCancellationReason["ServicerDelayApprovalShortSaleOffer"] = "SERVICER_DELAY_APPROVAL_SHORT_SALE_OFFER";
    ClosingCancellationReason["ServicerTerminationNonArmsLength"] = "SERVICER_TERMINATION_NON_ARMS_LENGTH";
    ClosingCancellationReason["ShortSaleIssue"] = "SHORT_SALE_ISSUE";
    ClosingCancellationReason["ShortSaleOfferRejectedBorrower"] = "SHORT_SALE_OFFER_REJECTED_BORROWER";
    ClosingCancellationReason["ShortSaleOfferRejectedMiCompany"] = "SHORT_SALE_OFFER_REJECTED_MI_COMPANY";
    ClosingCancellationReason["ShortSaleOfferRejectedServicer"] = "SHORT_SALE_OFFER_REJECTED_SERVICER";
    ClosingCancellationReason["TitleCompanyPerformance"] = "TITLE_COMPANY_PERFORMANCE";
    ClosingCancellationReason["TitleIssues"] = "TITLE_ISSUES";
    ClosingCancellationReason["UncooperativeOccupant"] = "UNCOOPERATIVE_OCCUPANT";
})(ClosingCancellationReason || (ClosingCancellationReason = {}));
var ClosingOverviewProjectionGroupingKey;
(function (ClosingOverviewProjectionGroupingKey) {
    ClosingOverviewProjectionGroupingKey["TransactionCoordinator"] = "TRANSACTION_COORDINATOR";
})(ClosingOverviewProjectionGroupingKey || (ClosingOverviewProjectionGroupingKey = {}));
var ClosingRelationship;
(function (ClosingRelationship) {
    ClosingRelationship["Auditor"] = "AUDITOR";
    ClosingRelationship["Bidder"] = "BIDDER";
    ClosingRelationship["Buyer"] = "BUYER";
    ClosingRelationship["BuyerAgent"] = "BUYER_AGENT";
    ClosingRelationship["Cobuyer"] = "COBUYER";
    ClosingRelationship["EscrowCompany"] = "ESCROW_COMPANY";
    ClosingRelationship["Lender"] = "LENDER";
    ClosingRelationship["ListingAgent"] = "LISTING_AGENT";
    ClosingRelationship["Seller"] = "SELLER";
    ClosingRelationship["TransactionCoordinator"] = "TRANSACTION_COORDINATOR";
    ClosingRelationship["WinningBidder"] = "WINNING_BIDDER";
})(ClosingRelationship || (ClosingRelationship = {}));
var CommissionPayerType;
(function (CommissionPayerType) {
    CommissionPayerType["Buyer"] = "BUYER";
    CommissionPayerType["Seller"] = "SELLER";
})(CommissionPayerType || (CommissionPayerType = {}));
var CommissionStrategyType;
(function (CommissionStrategyType) {
    CommissionStrategyType["Dollar"] = "DOLLAR";
    CommissionStrategyType["Invalid"] = "INVALID";
    CommissionStrategyType["NotSet"] = "NOT_SET";
    CommissionStrategyType["Percentage"] = "PERCENTAGE";
})(CommissionStrategyType || (CommissionStrategyType = {}));
var CommunicationMethod;
(function (CommunicationMethod) {
    CommunicationMethod["Email"] = "EMAIL";
    CommunicationMethod["PhoneCall"] = "PHONE_CALL";
    CommunicationMethod["PhoneText"] = "PHONE_TEXT";
})(CommunicationMethod || (CommunicationMethod = {}));
var ConsumerListingCompletionStatus;
(function (ConsumerListingCompletionStatus) {
    ConsumerListingCompletionStatus["ClosingInformation"] = "CLOSING_INFORMATION";
    ConsumerListingCompletionStatus["Completed"] = "COMPLETED";
    ConsumerListingCompletionStatus["ListingDetails"] = "LISTING_DETAILS";
    ConsumerListingCompletionStatus["NotStarted"] = "NOT_STARTED";
    ConsumerListingCompletionStatus["PropertyPhotos"] = "PROPERTY_PHOTOS";
    ConsumerListingCompletionStatus["PropertyValuations"] = "PROPERTY_VALUATIONS";
    ConsumerListingCompletionStatus["TitleInformation"] = "TITLE_INFORMATION";
    ConsumerListingCompletionStatus["Unknown"] = "UNKNOWN";
})(ConsumerListingCompletionStatus || (ConsumerListingCompletionStatus = {}));
var ConsumerListingDocumentPurposeType;
(function (ConsumerListingDocumentPurposeType) {
    ConsumerListingDocumentPurposeType["AgentValuation"] = "AGENT_VALUATION";
    ConsumerListingDocumentPurposeType["ClosingAddendum"] = "CLOSING_ADDENDUM";
    ConsumerListingDocumentPurposeType["Invalid"] = "INVALID";
    ConsumerListingDocumentPurposeType["LienDocument"] = "LIEN_DOCUMENT";
    ConsumerListingDocumentPurposeType["ListingAgreement"] = "LISTING_AGREEMENT";
    ConsumerListingDocumentPurposeType["MlsSheet"] = "MLS_SHEET";
    ConsumerListingDocumentPurposeType["Others"] = "OTHERS";
    ConsumerListingDocumentPurposeType["PropertyDisclosures"] = "PROPERTY_DISCLOSURES";
    ConsumerListingDocumentPurposeType["TitleLienReport"] = "TITLE_LIEN_REPORT";
    ConsumerListingDocumentPurposeType["WireInstructions"] = "WIRE_INSTRUCTIONS";
})(ConsumerListingDocumentPurposeType || (ConsumerListingDocumentPurposeType = {}));
var ConsumerListingLienType;
(function (ConsumerListingLienType) {
    ConsumerListingLienType["HoaDemand"] = "HOA_DEMAND";
    ConsumerListingLienType["HudDayOne"] = "HUD_DAY_ONE";
    ConsumerListingLienType["Other"] = "OTHER";
    ConsumerListingLienType["PointOfSaleInspection"] = "POINT_OF_SALE_INSPECTION";
    ConsumerListingLienType["ProratedTax"] = "PRORATED_TAX";
    ConsumerListingLienType["Tax"] = "TAX";
    ConsumerListingLienType["Utilities"] = "UTILITIES";
})(ConsumerListingLienType || (ConsumerListingLienType = {}));
var ConsumerListingMoveOutPreference;
(function (ConsumerListingMoveOutPreference) {
    ConsumerListingMoveOutPreference["Invalid"] = "INVALID";
    ConsumerListingMoveOutPreference["LeaseBack"] = "LEASE_BACK";
    ConsumerListingMoveOutPreference["MoveOutAtClosing"] = "MOVE_OUT_AT_CLOSING";
    ConsumerListingMoveOutPreference["MoveOutAtSpecifiedDate"] = "MOVE_OUT_AT_SPECIFIED_DATE";
})(ConsumerListingMoveOutPreference || (ConsumerListingMoveOutPreference = {}));
var ConsumerListingPartyRole;
(function (ConsumerListingPartyRole) {
    ConsumerListingPartyRole["AuthorizedThirdParty"] = "AUTHORIZED_THIRD_PARTY";
    ConsumerListingPartyRole["Broker"] = "BROKER";
    ConsumerListingPartyRole["BrokerAgent"] = "BROKER_AGENT";
    ConsumerListingPartyRole["ListingAgent"] = "LISTING_AGENT";
    ConsumerListingPartyRole["SellerClosingCompany"] = "SELLER_CLOSING_COMPANY";
    ConsumerListingPartyRole["SellerClosingCompanyContact"] = "SELLER_CLOSING_COMPANY_CONTACT";
    ConsumerListingPartyRole["SellerVesting"] = "SELLER_VESTING";
})(ConsumerListingPartyRole || (ConsumerListingPartyRole = {}));
var ConsumerListingStatus;
(function (ConsumerListingStatus) {
    ConsumerListingStatus["AgentReviewRequested"] = "AGENT_REVIEW_REQUESTED";
    ConsumerListingStatus["AgentReviewStarted"] = "AGENT_REVIEW_STARTED";
    ConsumerListingStatus["AgentReviewSubmitted"] = "AGENT_REVIEW_SUBMITTED";
    ConsumerListingStatus["Review"] = "REVIEW";
    ConsumerListingStatus["ReviewComplete"] = "REVIEW_COMPLETE";
    ConsumerListingStatus["Unknown"] = "UNKNOWN";
})(ConsumerListingStatus || (ConsumerListingStatus = {}));
var CriedBy;
(function (CriedBy) {
    CriedBy["Auctioneering"] = "AUCTIONEERING";
    CriedBy["Concierge"] = "CONCIERGE";
})(CriedBy || (CriedBy = {}));
var CurrentTargetAudience;
(function (CurrentTargetAudience) {
    CurrentTargetAudience["Buyer"] = "BUYER";
    CurrentTargetAudience["Seller"] = "SELLER";
    CurrentTargetAudience["Staff"] = "STAFF";
})(CurrentTargetAudience || (CurrentTargetAudience = {}));
var CustomerType;
(function (CustomerType) {
    CustomerType["Owner"] = "OWNER";
    CustomerType["Representative"] = "REPRESENTATIVE";
})(CustomerType || (CustomerType = {}));
var DeedMailingAddressTo;
(function (DeedMailingAddressTo) {
    DeedMailingAddressTo["Manual"] = "MANUAL";
    DeedMailingAddressTo["Other"] = "OTHER";
    DeedMailingAddressTo["Owner"] = "OWNER";
    DeedMailingAddressTo["Representative"] = "REPRESENTATIVE";
    DeedMailingAddressTo["Unknown"] = "UNKNOWN";
})(DeedMailingAddressTo || (DeedMailingAddressTo = {}));
var DeviceStatus;
(function (DeviceStatus) {
    DeviceStatus["Active"] = "ACTIVE";
    DeviceStatus["Inactive"] = "INACTIVE";
})(DeviceStatus || (DeviceStatus = {}));
var DeviceTokenProvider;
(function (DeviceTokenProvider) {
    DeviceTokenProvider["Apn"] = "APN";
    DeviceTokenProvider["Fcm"] = "FCM";
})(DeviceTokenProvider || (DeviceTokenProvider = {}));
var DirectOfferActivityType;
(function (DirectOfferActivityType) {
    DirectOfferActivityType["Accepted"] = "ACCEPTED";
    DirectOfferActivityType["AutoDecline"] = "AUTO_DECLINE";
    DirectOfferActivityType["AutoWithdraw"] = "AUTO_WITHDRAW";
    DirectOfferActivityType["Countered"] = "COUNTERED";
    DirectOfferActivityType["Declined"] = "DECLINED";
    DirectOfferActivityType["Expired"] = "EXPIRED";
    DirectOfferActivityType["Fallout"] = "FALLOUT";
    DirectOfferActivityType["Reviewed"] = "REVIEWED";
    DirectOfferActivityType["Submitted"] = "SUBMITTED";
    DirectOfferActivityType["Withdrawn"] = "WITHDRAWN";
})(DirectOfferActivityType || (DirectOfferActivityType = {}));
var DirectOfferBuyerAction;
(function (DirectOfferBuyerAction) {
    DirectOfferBuyerAction["Accept"] = "ACCEPT";
    DirectOfferBuyerAction["Counter"] = "COUNTER";
    DirectOfferBuyerAction["Decline"] = "DECLINE";
    DirectOfferBuyerAction["Withdraw"] = "WITHDRAW";
})(DirectOfferBuyerAction || (DirectOfferBuyerAction = {}));
var DirectOfferCategory;
(function (DirectOfferCategory) {
    DirectOfferCategory["Active"] = "ACTIVE";
    DirectOfferCategory["Inactive"] = "INACTIVE";
    DirectOfferCategory["Won"] = "WON";
})(DirectOfferCategory || (DirectOfferCategory = {}));
var DirectOfferEventAction;
(function (DirectOfferEventAction) {
    DirectOfferEventAction["Accepted"] = "ACCEPTED";
    DirectOfferEventAction["AutoDecline"] = "AUTO_DECLINE";
    DirectOfferEventAction["AutoWithdraw"] = "AUTO_WITHDRAW";
    DirectOfferEventAction["Countered"] = "COUNTERED";
    DirectOfferEventAction["Created"] = "CREATED";
    DirectOfferEventAction["Declined"] = "DECLINED";
    DirectOfferEventAction["Expired"] = "EXPIRED";
    DirectOfferEventAction["Fallout"] = "FALLOUT";
    DirectOfferEventAction["Reviewed"] = "REVIEWED";
    DirectOfferEventAction["Withdrawn"] = "WITHDRAWN";
})(DirectOfferEventAction || (DirectOfferEventAction = {}));
var DirectOfferStatus;
(function (DirectOfferStatus) {
    DirectOfferStatus["Accepted"] = "ACCEPTED";
    DirectOfferStatus["AutoDecline"] = "AUTO_DECLINE";
    DirectOfferStatus["AutoWithdraw"] = "AUTO_WITHDRAW";
    DirectOfferStatus["Countered"] = "COUNTERED";
    DirectOfferStatus["Declined"] = "DECLINED";
    DirectOfferStatus["Expired"] = "EXPIRED";
    DirectOfferStatus["Fallout"] = "FALLOUT";
    DirectOfferStatus["Pending"] = "PENDING";
    DirectOfferStatus["Withdrawn"] = "WITHDRAWN";
})(DirectOfferStatus || (DirectOfferStatus = {}));
var DirectOfferType;
(function (DirectOfferType) {
    DirectOfferType["Counter"] = "COUNTER";
    DirectOfferType["Initial"] = "INITIAL";
})(DirectOfferType || (DirectOfferType = {}));
var DirectOfferUserType;
(function (DirectOfferUserType) {
    DirectOfferUserType["Buyer"] = "BUYER";
    DirectOfferUserType["Seller"] = "SELLER";
    DirectOfferUserType["System"] = "SYSTEM";
})(DirectOfferUserType || (DirectOfferUserType = {}));
var DocumentExternalIdentifierType;
(function (DocumentExternalIdentifierType) {
    DocumentExternalIdentifierType["ReoOfferCancellation"] = "REO_OFFER_CANCELLATION";
    DocumentExternalIdentifierType["ReoOfferContract"] = "REO_OFFER_CONTRACT";
    DocumentExternalIdentifierType["ReoOfferExtension"] = "REO_OFFER_EXTENSION";
})(DocumentExternalIdentifierType || (DocumentExternalIdentifierType = {}));
var DomainEventTypeName;
(function (DomainEventTypeName) {
    DomainEventTypeName["DebugTriggered"] = "DEBUG__TRIGGERED";
    DomainEventTypeName["ListingCardClicked"] = "LISTING_CARD__CLICKED";
    DomainEventTypeName["PageViewed"] = "PAGE__VIEWED";
    DomainEventTypeName["SearchResultsPageFilterChanged"] = "SEARCH_RESULTS_PAGE__FILTER_CHANGED";
    DomainEventTypeName["SearchResultsPageResponseReceived"] = "SEARCH_RESULTS_PAGE__RESPONSE_RECEIVED";
})(DomainEventTypeName || (DomainEventTypeName = {}));
var Emd_Requirement;
(function (Emd_Requirement) {
    Emd_Requirement["AfterAuction"] = "AFTER_AUCTION";
    Emd_Requirement["AfterBuyerExecutes"] = "AFTER_BUYER_EXECUTES";
    Emd_Requirement["AfterSellerExecutes"] = "AFTER_SELLER_EXECUTES";
    Emd_Requirement["DateBuyerSigns"] = "DATE_BUYER_SIGNS";
})(Emd_Requirement || (Emd_Requirement = {}));
var EventType;
(function (EventType) {
    EventType["Live"] = "LIVE";
    EventType["Online"] = "ONLINE";
    EventType["ThirdParty"] = "THIRD_PARTY";
})(EventType || (EventType = {}));
var ExternalBidderSourceType;
(function (ExternalBidderSourceType) {
    ExternalBidderSourceType["External"] = "EXTERNAL";
    ExternalBidderSourceType["Uaa"] = "UAA";
    ExternalBidderSourceType["Unspecified"] = "UNSPECIFIED";
})(ExternalBidderSourceType || (ExternalBidderSourceType = {}));
var ExternalSyncStatus;
(function (ExternalSyncStatus) {
    ExternalSyncStatus["Pending"] = "PENDING";
    ExternalSyncStatus["Success"] = "SUCCESS";
})(ExternalSyncStatus || (ExternalSyncStatus = {}));
var ExternallySubmittedSalesResultType;
(function (ExternallySubmittedSalesResultType) {
    ExternallySubmittedSalesResultType["Reverted"] = "REVERTED";
    ExternallySubmittedSalesResultType["Sold"] = "SOLD";
})(ExternallySubmittedSalesResultType || (ExternallySubmittedSalesResultType = {}));
var FalloutCausedBy;
(function (FalloutCausedBy) {
    FalloutCausedBy["Adc"] = "ADC";
    FalloutCausedBy["Buyer"] = "BUYER";
    FalloutCausedBy["Property"] = "PROPERTY";
    FalloutCausedBy["Seller"] = "SELLER";
})(FalloutCausedBy || (FalloutCausedBy = {}));
var FalloutReason;
(function (FalloutReason) {
    FalloutReason["AdcEvictionPledge"] = "ADC_EVICTION_PLEDGE";
    FalloutReason["AttorneyRequest"] = "ATTORNEY_REQUEST";
    FalloutReason["BiddingError"] = "BIDDING_ERROR";
    FalloutReason["BidTooMuch"] = "BID_TOO_MUCH";
    FalloutReason["BuyerNotHudApprovedNonProfit"] = "BUYER_NOT_HUD_APPROVED_NON_PROFIT";
    FalloutReason["BuyerNotQualified"] = "BUYER_NOT_QUALIFIED";
    FalloutReason["BuyerPremiumIssues"] = "BUYER_PREMIUM_ISSUES";
    FalloutReason["BuyerWalked"] = "BUYER_WALKED";
    FalloutReason["ClerkingError"] = "CLERKING_ERROR";
    FalloutReason["DamageAfterAuction"] = "DAMAGE_AFTER_AUCTION";
    FalloutReason["Emergency"] = "EMERGENCY";
    FalloutReason["EntityIssues"] = "ENTITY_ISSUES";
    FalloutReason["FailedFinancing"] = "FAILED_FINANCING";
    FalloutReason["FailedToDisclose"] = "FAILED_TO_DISCLOSE";
    FalloutReason["GovernmentEntityNotApproved"] = "GOVERNMENT_ENTITY_NOT_APPROVED";
    FalloutReason["HoaIssues"] = "HOA_ISSUES";
    FalloutReason["NaturalDisaster"] = "NATURAL_DISASTER";
    FalloutReason["NonPerformance"] = "NON_PERFORMANCE";
    FalloutReason["NonResponsive"] = "NON_RESPONSIVE";
    FalloutReason["PoorOnlineReviews"] = "POOR_ONLINE_REVIEWS";
    FalloutReason["PropertyCondition"] = "PROPERTY_CONDITION";
    FalloutReason["PropertyDescription"] = "PROPERTY_DESCRIPTION";
    FalloutReason["ReClerk"] = "RE_CLERK";
    FalloutReason["SellerCancellation"] = "SELLER_CANCELLATION";
    FalloutReason["SellerRejection"] = "SELLER_REJECTION";
    FalloutReason["SellerRemoval"] = "SELLER_REMOVAL";
    FalloutReason["ServiceRelease"] = "SERVICE_RELEASE";
    FalloutReason["SuspendedBuyer"] = "SUSPENDED_BUYER";
    FalloutReason["SystemIssue"] = "SYSTEM_ISSUE";
    FalloutReason["TermsAndConditions"] = "TERMS_AND_CONDITIONS";
    FalloutReason["TitleIssues"] = "TITLE_ISSUES";
    FalloutReason["TypeOfAsset"] = "TYPE_OF_ASSET";
    FalloutReason["UnacceptablePof"] = "UNACCEPTABLE_POF";
    FalloutReason["UpsetBid"] = "UPSET_BID";
})(FalloutReason || (FalloutReason = {}));
var FinanceTransactionStatus;
(function (FinanceTransactionStatus) {
    FinanceTransactionStatus["AssetCreateFail"] = "ASSET_CREATE_FAIL";
    FinanceTransactionStatus["AssetCreateSuccess"] = "ASSET_CREATE_SUCCESS";
    FinanceTransactionStatus["AssetUpdateFail"] = "ASSET_UPDATE_FAIL";
    FinanceTransactionStatus["AssetUpdateSuccess"] = "ASSET_UPDATE_SUCCESS";
    FinanceTransactionStatus["CustomerCreateFail"] = "CUSTOMER_CREATE_FAIL";
    FinanceTransactionStatus["CustomerUpdateFail"] = "CUSTOMER_UPDATE_FAIL";
    FinanceTransactionStatus["CustomerUpdateSuccess"] = "CUSTOMER_UPDATE_SUCCESS";
    FinanceTransactionStatus["InvoiceCreateFail"] = "INVOICE_CREATE_FAIL";
    FinanceTransactionStatus["InvoiceCreateSuccess"] = "INVOICE_CREATE_SUCCESS";
    FinanceTransactionStatus["SubmissionReady"] = "SUBMISSION_READY";
    FinanceTransactionStatus["VenueCreateFail"] = "VENUE_CREATE_FAIL";
    FinanceTransactionStatus["VenueCreateSuccess"] = "VENUE_CREATE_SUCCESS";
    FinanceTransactionStatus["VenueUpdateFail"] = "VENUE_UPDATE_FAIL";
    FinanceTransactionStatus["VenueUpdateSuccess"] = "VENUE_UPDATE_SUCCESS";
})(FinanceTransactionStatus || (FinanceTransactionStatus = {}));
var FinanceType;
(function (FinanceType) {
    FinanceType["Cash"] = "CASH";
    FinanceType["Check"] = "CHECK";
    FinanceType["Conventional"] = "CONVENTIONAL";
    FinanceType["Fha"] = "FHA";
    FinanceType["Fha_203B"] = "FHA_203B";
    FinanceType["Fha_203BRepairEscrow"] = "FHA_203B_REPAIR_ESCROW";
    FinanceType["Fha_203K"] = "FHA_203K";
    FinanceType["HardMoneyLoan"] = "HARD_MONEY_LOAN";
    FinanceType["Heloc"] = "HELOC";
    FinanceType["Irc_1031Exchange"] = "IRC_1031_EXCHANGE";
    FinanceType["LineOfCredit"] = "LINE_OF_CREDIT";
    FinanceType["Other"] = "OTHER";
    FinanceType["RehabLoan"] = "REHAB_LOAN";
    FinanceType["Usda"] = "USDA";
    FinanceType["Va"] = "VA";
    FinanceType["Wire"] = "WIRE";
})(FinanceType || (FinanceType = {}));
var FirstLookBuyerSelectionType;
(function (FirstLookBuyerSelectionType) {
    FirstLookBuyerSelectionType["EntityApproved"] = "ENTITY_APPROVED";
    FirstLookBuyerSelectionType["Homebuyer"] = "HOMEBUYER";
    FirstLookBuyerSelectionType["Investor"] = "INVESTOR";
})(FirstLookBuyerSelectionType || (FirstLookBuyerSelectionType = {}));
var FormattedAddressFormat;
(function (FormattedAddressFormat) {
    FormattedAddressFormat["DoubleLine"] = "DOUBLE_LINE";
    FormattedAddressFormat["SingleLine"] = "SINGLE_LINE";
})(FormattedAddressFormat || (FormattedAddressFormat = {}));
var FundModificationStatus;
(function (FundModificationStatus) {
    FundModificationStatus["Altered"] = "ALTERED";
    FundModificationStatus["Original"] = "ORIGINAL";
})(FundModificationStatus || (FundModificationStatus = {}));
var FundReconciliationStatus;
(function (FundReconciliationStatus) {
    FundReconciliationStatus["Pending"] = "PENDING";
    FundReconciliationStatus["Settled"] = "SETTLED";
})(FundReconciliationStatus || (FundReconciliationStatus = {}));
var FundStatus;
(function (FundStatus) {
    FundStatus["Approved"] = "APPROVED";
    FundStatus["Denied"] = "DENIED";
    FundStatus["Pending"] = "PENDING";
    FundStatus["Suspended"] = "SUSPENDED";
})(FundStatus || (FundStatus = {}));
var FundTransactionType;
(function (FundTransactionType) {
    FundTransactionType["Credit"] = "CREDIT";
    FundTransactionType["Debit"] = "DEBIT";
})(FundTransactionType || (FundTransactionType = {}));
var GlobalMediaPriorityLevel;
(function (GlobalMediaPriorityLevel) {
    GlobalMediaPriorityLevel["High"] = "HIGH";
    GlobalMediaPriorityLevel["Highest"] = "HIGHEST";
    GlobalMediaPriorityLevel["Low"] = "LOW";
    GlobalMediaPriorityLevel["Lowest"] = "LOWEST";
    GlobalMediaPriorityLevel["Medium"] = "MEDIUM";
})(GlobalMediaPriorityLevel || (GlobalMediaPriorityLevel = {}));
var GlobalMediaPurpose;
(function (GlobalMediaPurpose) {
    GlobalMediaPurpose["BrokerProtectionAgreement"] = "BROKER_PROTECTION_AGREEMENT";
    GlobalMediaPurpose["DepositRequirement"] = "DEPOSIT_REQUIREMENT";
    GlobalMediaPurpose["Disclosure"] = "DISCLOSURE";
    GlobalMediaPurpose["HomeWarranty"] = "HOME_WARRANTY";
    GlobalMediaPurpose["Misc"] = "MISC";
    GlobalMediaPurpose["PurchaserInformationForm"] = "PURCHASER_INFORMATION_FORM";
    GlobalMediaPurpose["PurchaseAgreement"] = "PURCHASE_AGREEMENT";
    GlobalMediaPurpose["PurchaseAgreementAddendum"] = "PURCHASE_AGREEMENT_ADDENDUM";
    GlobalMediaPurpose["SampleDeed"] = "SAMPLE_DEED";
    GlobalMediaPurpose["SampleThirdPartyTitleReport"] = "SAMPLE_THIRD_PARTY_TITLE_REPORT";
    GlobalMediaPurpose["SampleTrusteeCertOfSale"] = "SAMPLE_TRUSTEE_CERT_OF_SALE";
    GlobalMediaPurpose["TaxForm"] = "TAX_FORM";
    GlobalMediaPurpose["TermsAndConditions"] = "TERMS_AND_CONDITIONS";
})(GlobalMediaPurpose || (GlobalMediaPurpose = {}));
var GlobalMediaUsage;
(function (GlobalMediaUsage) {
    GlobalMediaUsage["Contracting"] = "CONTRACTING";
    GlobalMediaUsage["Internal"] = "INTERNAL";
    GlobalMediaUsage["Live"] = "LIVE";
    GlobalMediaUsage["Marketing"] = "MARKETING";
    GlobalMediaUsage["Web"] = "WEB";
})(GlobalMediaUsage || (GlobalMediaUsage = {}));
var IntacctTransactionStatus;
(function (IntacctTransactionStatus) {
    IntacctTransactionStatus["AssetCreateFail"] = "ASSET_CREATE_FAIL";
    IntacctTransactionStatus["AssetCreateSuccess"] = "ASSET_CREATE_SUCCESS";
    IntacctTransactionStatus["AssetUpdateFail"] = "ASSET_UPDATE_FAIL";
    IntacctTransactionStatus["AssetUpdateSuccess"] = "ASSET_UPDATE_SUCCESS";
    IntacctTransactionStatus["InvoiceCreateFail"] = "INVOICE_CREATE_FAIL";
    IntacctTransactionStatus["InvoiceCreateSuccess"] = "INVOICE_CREATE_SUCCESS";
    IntacctTransactionStatus["SubmissionReady"] = "SUBMISSION_READY";
})(IntacctTransactionStatus || (IntacctTransactionStatus = {}));
var IntakeMethodType;
(function (IntakeMethodType) {
    IntakeMethodType["ListingPortal"] = "LISTING_PORTAL";
    IntakeMethodType["Salesforce"] = "SALESFORCE";
    IntakeMethodType["SalesforceLeads"] = "SALESFORCE_LEADS";
    IntakeMethodType["Syndication"] = "SYNDICATION";
})(IntakeMethodType || (IntakeMethodType = {}));
var InvitationFilterPartyRole;
(function (InvitationFilterPartyRole) {
    InvitationFilterPartyRole["Recipient"] = "RECIPIENT";
    InvitationFilterPartyRole["Sender"] = "SENDER";
})(InvitationFilterPartyRole || (InvitationFilterPartyRole = {}));
var InvitationIntent;
(function (InvitationIntent) {
    InvitationIntent["ConsumerListingCreation"] = "CONSUMER_LISTING_CREATION";
    InvitationIntent["ConsumerListingPartyAssociation"] = "CONSUMER_LISTING_PARTY_ASSOCIATION";
    InvitationIntent["ContractingListing"] = "CONTRACTING_LISTING";
    InvitationIntent["NewAccount"] = "NEW_ACCOUNT";
})(InvitationIntent || (InvitationIntent = {}));
var InvitationRelativeType;
(function (InvitationRelativeType) {
    InvitationRelativeType["Listing"] = "LISTING";
})(InvitationRelativeType || (InvitationRelativeType = {}));
var InvitationStatus;
(function (InvitationStatus) {
    InvitationStatus["Accepted"] = "ACCEPTED";
    InvitationStatus["Declined"] = "DECLINED";
    InvitationStatus["Expired"] = "EXPIRED";
    InvitationStatus["Pending"] = "PENDING";
    InvitationStatus["Revoked"] = "REVOKED";
})(InvitationStatus || (InvitationStatus = {}));
var LawCode;
(function (LawCode) {
    LawCode["Ab2424"] = "AB2424";
    LawCode["Sb1079"] = "SB1079";
})(LawCode || (LawCode = {}));
var LeadAuctionType;
(function (LeadAuctionType) {
    LeadAuctionType["Auctioneering"] = "AUCTIONEERING";
    LeadAuctionType["Concierge"] = "CONCIERGE";
})(LeadAuctionType || (LeadAuctionType = {}));
var LeadExceptionType;
(function (LeadExceptionType) {
    LeadExceptionType["LessThanFifteenMarketingDays"] = "LESS_THAN_FIFTEEN_MARKETING_DAYS";
    LeadExceptionType["PendingAttorneyCreditBid"] = "PENDING_ATTORNEY_CREDIT_BID";
    LeadExceptionType["PendingAttorneyReferral"] = "PENDING_ATTORNEY_REFERRAL";
    LeadExceptionType["PendingInvestor"] = "PENDING_INVESTOR";
    LeadExceptionType["PendingLoanType"] = "PENDING_LOAN_TYPE";
    LeadExceptionType["PendingSaleTime"] = "PENDING_SALE_TIME";
    LeadExceptionType["PendingServicerBid"] = "PENDING_SERVICER_BID";
    LeadExceptionType["PendingServicerReferral"] = "PENDING_SERVICER_REFERRAL";
    LeadExceptionType["PendingTotalDebt"] = "PENDING_TOTAL_DEBT";
})(LeadExceptionType || (LeadExceptionType = {}));
var LeadIntakeProgramType;
(function (LeadIntakeProgramType) {
    LeadIntakeProgramType["PreForeclosure"] = "PRE_FORECLOSURE";
    LeadIntakeProgramType["SellWithUs"] = "SELL_WITH_US";
})(LeadIntakeProgramType || (LeadIntakeProgramType = {}));
var LeadIntakeSyncStatus;
(function (LeadIntakeSyncStatus) {
    LeadIntakeSyncStatus["Failed"] = "FAILED";
    LeadIntakeSyncStatus["Pending"] = "PENDING";
    LeadIntakeSyncStatus["Success"] = "SUCCESS";
})(LeadIntakeSyncStatus || (LeadIntakeSyncStatus = {}));
var LegalConstraintCode;
(function (LegalConstraintCode) {
    LegalConstraintCode["ReauctionIfReserveLessThanStartingBid"] = "REAUCTION_IF_RESERVE_LESS_THAN_STARTING_BID";
})(LegalConstraintCode || (LegalConstraintCode = {}));
var ListingClosingResponsibilityType;
(function (ListingClosingResponsibilityType) {
    ListingClosingResponsibilityType["AuctionStandard"] = "AUCTION_STANDARD";
    ListingClosingResponsibilityType["AuctionTransactionDetails"] = "AUCTION_TRANSACTION_DETAILS";
    ListingClosingResponsibilityType["None"] = "NONE";
})(ListingClosingResponsibilityType || (ListingClosingResponsibilityType = {}));
var ListingDeedType;
(function (ListingDeedType) {
    ListingDeedType["QdAssignmentCert"] = "QD_ASSIGNMENT_CERT";
    ListingDeedType["QdAssignmentInterest"] = "QD_ASSIGNMENT_INTEREST";
    ListingDeedType["QuitclaimDeed"] = "QUITCLAIM_DEED";
    ListingDeedType["ReleaseDeed"] = "RELEASE_DEED";
    ListingDeedType["SpecialWarrantyDeed"] = "SPECIAL_WARRANTY_DEED";
    ListingDeedType["TrusteeDeed"] = "TRUSTEE_DEED";
    ListingDeedType["WarrantyDeed"] = "WARRANTY_DEED";
})(ListingDeedType || (ListingDeedType = {}));
var ListingExternalIdentifierDataSource;
(function (ListingExternalIdentifierDataSource) {
    ListingExternalIdentifierDataSource["GlobalPropertyId"] = "GLOBAL_PROPERTY_ID";
    ListingExternalIdentifierDataSource["Mlh"] = "MLH";
    ListingExternalIdentifierDataSource["MlhPropertyId"] = "MLH_PROPERTY_ID";
    ListingExternalIdentifierDataSource["RcpPropertyId"] = "RCP_PROPERTY_ID";
    ListingExternalIdentifierDataSource["SfdcAssetId"] = "SFDC_ASSET_ID";
    ListingExternalIdentifierDataSource["SyndicationPropertyId"] = "SYNDICATION_PROPERTY_ID";
    ListingExternalIdentifierDataSource["SyndicationPropertyUrl"] = "SYNDICATION_PROPERTY_URL";
    ListingExternalIdentifierDataSource["Trinity"] = "TRINITY";
    ListingExternalIdentifierDataSource["TrinityPid"] = "TRINITY_PID";
})(ListingExternalIdentifierDataSource || (ListingExternalIdentifierDataSource = {}));
var ListingFinanceType;
(function (ListingFinanceType) {
    ListingFinanceType["Cash"] = "CASH";
    ListingFinanceType["Conventional"] = "CONVENTIONAL";
    ListingFinanceType["Fha"] = "FHA";
    ListingFinanceType["Fha203K"] = "FHA203K";
    ListingFinanceType["Fha_203B"] = "FHA_203B";
    ListingFinanceType["Fha_203BRepairEscrow"] = "FHA_203B_REPAIR_ESCROW";
    ListingFinanceType["Fha_203K"] = "FHA_203K";
    ListingFinanceType["HardMoneyLoan"] = "HARD_MONEY_LOAN";
    ListingFinanceType["LineOfCredit"] = "LINE_OF_CREDIT";
    ListingFinanceType["Other"] = "OTHER";
    ListingFinanceType["Va"] = "VA";
})(ListingFinanceType || (ListingFinanceType = {}));
var ListingGroupType;
(function (ListingGroupType) {
    ListingGroupType["Campaign"] = "CAMPAIGN";
    ListingGroupType["Venue"] = "VENUE";
})(ListingGroupType || (ListingGroupType = {}));
var ListingLandOwnershipType;
(function (ListingLandOwnershipType) {
    ListingLandOwnershipType["FeeSimple"] = "FEE_SIMPLE";
    ListingLandOwnershipType["Leasehold"] = "LEASEHOLD";
})(ListingLandOwnershipType || (ListingLandOwnershipType = {}));
var ListingMoveOutPreference;
(function (ListingMoveOutPreference) {
    ListingMoveOutPreference["Leaseback"] = "LEASEBACK";
    ListingMoveOutPreference["MoveOutAtClosing"] = "MOVE_OUT_AT_CLOSING";
    ListingMoveOutPreference["MoveOutAtSpecifiedDate"] = "MOVE_OUT_AT_SPECIFIED_DATE";
    ListingMoveOutPreference["Unknown"] = "UNKNOWN";
})(ListingMoveOutPreference || (ListingMoveOutPreference = {}));
var ListingPaidBy;
(function (ListingPaidBy) {
    ListingPaidBy["Adc"] = "ADC";
    ListingPaidBy["Buyer"] = "BUYER";
    ListingPaidBy["Seller"] = "SELLER";
})(ListingPaidBy || (ListingPaidBy = {}));
var ListingPartyRole;
(function (ListingPartyRole) {
    ListingPartyRole["AssetManager"] = "ASSET_MANAGER";
    ListingPartyRole["AuctionClosingCompany"] = "AUCTION_CLOSING_COMPANY";
    ListingPartyRole["AuctionClosingCompanyContact"] = "AUCTION_CLOSING_COMPANY_CONTACT";
    ListingPartyRole["Beneficiary"] = "BENEFICIARY";
    ListingPartyRole["BeneficiaryContact"] = "BENEFICIARY_CONTACT";
    ListingPartyRole["Broker"] = "BROKER";
    ListingPartyRole["BrokerAgent"] = "BROKER_AGENT";
    ListingPartyRole["BrokerAgentContact"] = "BROKER_AGENT_CONTACT";
    ListingPartyRole["BrokerContact"] = "BROKER_CONTACT";
    ListingPartyRole["ContractClosingCompany"] = "CONTRACT_CLOSING_COMPANY";
    ListingPartyRole["ContractClosingCompanyContact"] = "CONTRACT_CLOSING_COMPANY_CONTACT";
    ListingPartyRole["EscrowOffice"] = "ESCROW_OFFICE";
    ListingPartyRole["EscrowOfficer"] = "ESCROW_OFFICER";
    ListingPartyRole["EscrowOfficerContact"] = "ESCROW_OFFICER_CONTACT";
    ListingPartyRole["EscrowOfficeContact"] = "ESCROW_OFFICE_CONTACT";
    ListingPartyRole["ForeclosureAttorney"] = "FORECLOSURE_ATTORNEY";
    ListingPartyRole["ForeclosureAttorneyContact"] = "FORECLOSURE_ATTORNEY_CONTACT";
    ListingPartyRole["Investor"] = "INVESTOR";
    ListingPartyRole["ListingAgent"] = "LISTING_AGENT";
    ListingPartyRole["ListingAgentContact"] = "LISTING_AGENT_CONTACT";
    ListingPartyRole["MortgageInsuranceCompany"] = "MORTGAGE_INSURANCE_COMPANY";
    ListingPartyRole["OriginalBeneficiary"] = "ORIGINAL_BENEFICIARY";
    ListingPartyRole["Outsourcer"] = "OUTSOURCER";
    ListingPartyRole["OutsourcerContact"] = "OUTSOURCER_CONTACT";
    ListingPartyRole["PrivateSeller"] = "PRIVATE_SELLER";
    ListingPartyRole["SellerAssetManager"] = "SELLER_ASSET_MANAGER";
    ListingPartyRole["SellerClosingCompany"] = "SELLER_CLOSING_COMPANY";
    ListingPartyRole["SellerClosingCompanyContact"] = "SELLER_CLOSING_COMPANY_CONTACT";
    ListingPartyRole["SellerVesting"] = "SELLER_VESTING";
    ListingPartyRole["SellerVestingContact"] = "SELLER_VESTING_CONTACT";
    ListingPartyRole["Servicer"] = "SERVICER";
    ListingPartyRole["ServicerAssetManagerContact"] = "SERVICER_ASSET_MANAGER_CONTACT";
    ListingPartyRole["ServicerContact"] = "SERVICER_CONTACT";
    ListingPartyRole["TitleCompany"] = "TITLE_COMPANY";
    ListingPartyRole["TitleCompanyContact"] = "TITLE_COMPANY_CONTACT";
    ListingPartyRole["TitleUnderwriter"] = "TITLE_UNDERWRITER";
    ListingPartyRole["Trustor"] = "TRUSTOR";
    ListingPartyRole["TrustorContact"] = "TRUSTOR_CONTACT";
    ListingPartyRole["WireInstructionCompany"] = "WIRE_INSTRUCTION_COMPANY";
    ListingPartyRole["WireInstructionCompanyContact"] = "WIRE_INSTRUCTION_COMPANY_CONTACT";
})(ListingPartyRole || (ListingPartyRole = {}));
var ListingPendingUpdateStatus;
(function (ListingPendingUpdateStatus) {
    ListingPendingUpdateStatus["Canceled"] = "CANCELED";
    ListingPendingUpdateStatus["None"] = "NONE";
    ListingPendingUpdateStatus["Postponed"] = "POSTPONED";
    ListingPendingUpdateStatus["SalePending"] = "SALE_PENDING";
    ListingPendingUpdateStatus["SalePendingCleared"] = "SALE_PENDING_CLEARED";
})(ListingPendingUpdateStatus || (ListingPendingUpdateStatus = {}));
var ListingProductClassification;
(function (ListingProductClassification) {
    ListingProductClassification["BankOwned"] = "BANK_OWNED";
    ListingProductClassification["Individual"] = "INDIVIDUAL";
    ListingProductClassification["Institutional"] = "INSTITUTIONAL";
    ListingProductClassification["MarketingOnly"] = "MARKETING_ONLY";
    ListingProductClassification["PreForeclosure"] = "PRE_FORECLOSURE";
})(ListingProductClassification || (ListingProductClassification = {}));
var ListingStatus;
(function (ListingStatus) {
    ListingStatus["AuctionInProgress"] = "AUCTION_IN_PROGRESS";
    ListingStatus["Canceled"] = "CANCELED";
    ListingStatus["Closed"] = "CLOSED";
    ListingStatus["EligibilityPending"] = "ELIGIBILITY_PENDING";
    ListingStatus["InClosing"] = "IN_CLOSING";
    ListingStatus["InStaging"] = "IN_STAGING";
    ListingStatus["NoSale"] = "NO_SALE";
    ListingStatus["OutbidPeriod"] = "OUTBID_PERIOD";
    ListingStatus["PendingScheduling"] = "PENDING_SCHEDULING";
    ListingStatus["Postponed"] = "POSTPONED";
    ListingStatus["PostponedPendingScheduling"] = "POSTPONED_PENDING_SCHEDULING";
    ListingStatus["Removed"] = "REMOVED";
    ListingStatus["SaleFailed"] = "SALE_FAILED";
    ListingStatus["SaleGatekeeping"] = "SALE_GATEKEEPING";
    ListingStatus["SalePaymentPending"] = "SALE_PAYMENT_PENDING";
    ListingStatus["SalePending"] = "SALE_PENDING";
    ListingStatus["SalePendingCleared"] = "SALE_PENDING_CLEARED";
    ListingStatus["SaleResultPending"] = "SALE_RESULT_PENDING";
    ListingStatus["Withdrawn"] = "WITHDRAWN";
})(ListingStatus || (ListingStatus = {}));
var ListingStatusGroup;
(function (ListingStatusGroup) {
    ListingStatusGroup["Active"] = "ACTIVE";
    ListingStatusGroup["Canceled"] = "CANCELED";
    ListingStatusGroup["Inactive"] = "INACTIVE";
    ListingStatusGroup["Pending"] = "PENDING";
    ListingStatusGroup["Removed"] = "REMOVED";
    ListingStatusGroup["Sold"] = "SOLD";
})(ListingStatusGroup || (ListingStatusGroup = {}));
var ListingStatusLabelIntent;
(function (ListingStatusLabelIntent) {
    ListingStatusLabelIntent["Pdp"] = "PDP";
    ListingStatusLabelIntent["Search"] = "SEARCH";
})(ListingStatusLabelIntent || (ListingStatusLabelIntent = {}));
var ListingStrategyBidDepositStrategy;
(function (ListingStrategyBidDepositStrategy) {
    ListingStrategyBidDepositStrategy["AdcStandardAmount"] = "ADC_STANDARD_AMOUNT";
    ListingStrategyBidDepositStrategy["NotRequired"] = "NOT_REQUIRED";
})(ListingStrategyBidDepositStrategy || (ListingStrategyBidDepositStrategy = {}));
var ListingStrategyClosingMethodType;
(function (ListingStrategyClosingMethodType) {
    ListingStrategyClosingMethodType["ReoOffer"] = "REO_OFFER";
    ListingStrategyClosingMethodType["TrusteeContract"] = "TRUSTEE_CONTRACT";
})(ListingStrategyClosingMethodType || (ListingStrategyClosingMethodType = {}));
var ListingStrategyPricingStrategy;
(function (ListingStrategyPricingStrategy) {
    ListingStrategyPricingStrategy["BandedByReserve"] = "BANDED_BY_RESERVE";
})(ListingStrategyPricingStrategy || (ListingStrategyPricingStrategy = {}));
var ListingStrategySellingMethodType;
(function (ListingStrategySellingMethodType) {
    ListingStrategySellingMethodType["DirectOfferAuction"] = "DIRECT_OFFER_AUCTION";
    ListingStrategySellingMethodType["LiveAuctionSegment"] = "LIVE_AUCTION_SEGMENT";
    ListingStrategySellingMethodType["OnlineAuctionSegment"] = "ONLINE_AUCTION_SEGMENT";
})(ListingStrategySellingMethodType || (ListingStrategySellingMethodType = {}));
var ListingTermsEnforcement;
(function (ListingTermsEnforcement) {
    ListingTermsEnforcement["Mandatory"] = "MANDATORY";
    ListingTermsEnforcement["Negotiable"] = "NEGOTIABLE";
})(ListingTermsEnforcement || (ListingTermsEnforcement = {}));
var ListingTitleInsurancePolicy;
(function (ListingTitleInsurancePolicy) {
    ListingTitleInsurancePolicy["BuyerToPay"] = "BUYER_TO_PAY";
    ListingTitleInsurancePolicy["NotOffered"] = "NOT_OFFERED";
    ListingTitleInsurancePolicy["ReferToPsa"] = "REFER_TO_PSA";
    ListingTitleInsurancePolicy["SellerToPay"] = "SELLER_TO_PAY";
})(ListingTitleInsurancePolicy || (ListingTitleInsurancePolicy = {}));
var LiveAuctionSegmentBidEndStatus;
(function (LiveAuctionSegmentBidEndStatus) {
    LiveAuctionSegmentBidEndStatus["Aborted"] = "ABORTED";
    LiveAuctionSegmentBidEndStatus["FinalizingBid"] = "FINALIZING_BID";
    LiveAuctionSegmentBidEndStatus["FinalAsk"] = "FINAL_ASK";
    LiveAuctionSegmentBidEndStatus["GoingOnce"] = "GOING_ONCE";
    LiveAuctionSegmentBidEndStatus["GoingTwice"] = "GOING_TWICE";
    LiveAuctionSegmentBidEndStatus["None"] = "NONE";
    LiveAuctionSegmentBidEndStatus["NoSale"] = "NO_SALE";
    LiveAuctionSegmentBidEndStatus["Postponed"] = "POSTPONED";
    LiveAuctionSegmentBidEndStatus["SaleFailed"] = "SALE_FAILED";
    LiveAuctionSegmentBidEndStatus["Sold"] = "SOLD";
})(LiveAuctionSegmentBidEndStatus || (LiveAuctionSegmentBidEndStatus = {}));
var LiveAuctionSegmentBidType;
(function (LiveAuctionSegmentBidType) {
    LiveAuctionSegmentBidType["BeneficiaryBid"] = "BENEFICIARY_BID";
    LiveAuctionSegmentBidType["Credit"] = "CREDIT";
    LiveAuctionSegmentBidType["NotRegistered"] = "NOT_REGISTERED";
    LiveAuctionSegmentBidType["OpeningBid"] = "OPENING_BID";
    LiveAuctionSegmentBidType["RegisteredUser"] = "REGISTERED_USER";
    LiveAuctionSegmentBidType["RemoteBid"] = "REMOTE_BID";
})(LiveAuctionSegmentBidType || (LiveAuctionSegmentBidType = {}));
var LiveAuctionSegmentBiddingStatus;
(function (LiveAuctionSegmentBiddingStatus) {
    LiveAuctionSegmentBiddingStatus["HighestBid"] = "HIGHEST_BID";
    LiveAuctionSegmentBiddingStatus["Lost"] = "LOST";
    LiveAuctionSegmentBiddingStatus["NoBid"] = "NO_BID";
    LiveAuctionSegmentBiddingStatus["Outbid"] = "OUTBID";
    LiveAuctionSegmentBiddingStatus["PlacingBid"] = "PLACING_BID";
    LiveAuctionSegmentBiddingStatus["Won"] = "WON";
})(LiveAuctionSegmentBiddingStatus || (LiveAuctionSegmentBiddingStatus = {}));
var LiveAuctionSegmentFileType;
(function (LiveAuctionSegmentFileType) {
    LiveAuctionSegmentFileType["AuctioneerSignature"] = "AUCTIONEER_SIGNATURE";
    LiveAuctionSegmentFileType["CryRecording"] = "CRY_RECORDING";
    LiveAuctionSegmentFileType["NoticeOfSale"] = "NOTICE_OF_SALE";
})(LiveAuctionSegmentFileType || (LiveAuctionSegmentFileType = {}));
var LiveAuctionStaffAssignmentType;
(function (LiveAuctionStaffAssignmentType) {
    LiveAuctionStaffAssignmentType["AutoAssign"] = "AUTO_ASSIGN";
    LiveAuctionStaffAssignmentType["Scheduled"] = "SCHEDULED";
    LiveAuctionStaffAssignmentType["SelfAssign"] = "SELF_ASSIGN";
})(LiveAuctionStaffAssignmentType || (LiveAuctionStaffAssignmentType = {}));
var LiveAuctionStaffRole;
(function (LiveAuctionStaffRole) {
    LiveAuctionStaffRole["Auctioneer"] = "AUCTIONEER";
    LiveAuctionStaffRole["AuctionManager"] = "AUCTION_MANAGER";
    LiveAuctionStaffRole["AuctionSupport"] = "AUCTION_SUPPORT";
    LiveAuctionStaffRole["Auditor"] = "AUDITOR";
    LiveAuctionStaffRole["Banker"] = "BANKER";
    LiveAuctionStaffRole["BidderRegistration"] = "BIDDER_REGISTRATION";
    LiveAuctionStaffRole["BidTracker"] = "BID_TRACKER";
    LiveAuctionStaffRole["Concierge"] = "CONCIERGE";
    LiveAuctionStaffRole["FloorManager"] = "FLOOR_MANAGER";
    LiveAuctionStaffRole["ReceiptWriter"] = "RECEIPT_WRITER";
    LiveAuctionStaffRole["Training"] = "TRAINING";
})(LiveAuctionStaffRole || (LiveAuctionStaffRole = {}));
var MaritalStatus;
(function (MaritalStatus) {
    MaritalStatus["HusbandAndHusband"] = "HUSBAND_AND_HUSBAND";
    MaritalStatus["HusbandAndWife"] = "HUSBAND_AND_WIFE";
    MaritalStatus["MarriedMan"] = "MARRIED_MAN";
    MaritalStatus["MarriedWoman"] = "MARRIED_WOMAN";
    MaritalStatus["Other"] = "OTHER";
    MaritalStatus["SingleMan"] = "SINGLE_MAN";
    MaritalStatus["SingleWoman"] = "SINGLE_WOMAN";
    MaritalStatus["UnmarriedMan"] = "UNMARRIED_MAN";
    MaritalStatus["UnmarriedWoman"] = "UNMARRIED_WOMAN";
    MaritalStatus["Widow"] = "WIDOW";
    MaritalStatus["Widower"] = "WIDOWER";
    MaritalStatus["WifeAndHusband"] = "WIFE_AND_HUSBAND";
    MaritalStatus["WifeAndWife"] = "WIFE_AND_WIFE";
})(MaritalStatus || (MaritalStatus = {}));
var MarketingAttributeClass;
(function (MarketingAttributeClass) {
    MarketingAttributeClass["Content"] = "CONTENT";
    MarketingAttributeClass["FeatureToggle"] = "FEATURE_TOGGLE";
})(MarketingAttributeClass || (MarketingAttributeClass = {}));
var MarketingAttributeType;
(function (MarketingAttributeType) {
    MarketingAttributeType["AuctioneerDialogueClearance"] = "AUCTIONEER_DIALOGUE_CLEARANCE";
    MarketingAttributeType["AuctioneerDialoguePostponement"] = "AUCTIONEER_DIALOGUE_POSTPONEMENT";
    MarketingAttributeType["AuctioneerLicensing"] = "AUCTIONEER_LICENSING";
    MarketingAttributeType["AuctionsyncAssetManagement"] = "AUCTIONSYNC_ASSET_MANAGEMENT";
    MarketingAttributeType["Contact"] = "CONTACT";
    MarketingAttributeType["CosDisclaimer"] = "COS_DISCLAIMER";
    MarketingAttributeType["CustomerServiceNumber"] = "CUSTOMER_SERVICE_NUMBER";
    MarketingAttributeType["Deposit"] = "DEPOSIT";
    MarketingAttributeType["DepositCheckVerbiage"] = "DEPOSIT_CHECK_VERBIAGE";
    MarketingAttributeType["Disclaimer"] = "DISCLAIMER";
    MarketingAttributeType["FclBuyerCosEmail"] = "FCL_BUYER_COS_EMAIL";
    MarketingAttributeType["FclTrusteeEmail"] = "FCL_TRUSTEE_EMAIL";
    MarketingAttributeType["FinalJudgementAmount"] = "FINAL_JUDGEMENT_AMOUNT";
    MarketingAttributeType["FirstLookSpecial"] = "FIRST_LOOK_SPECIAL";
    MarketingAttributeType["GeneralAnnouncement"] = "GENERAL_ANNOUNCEMENT";
    MarketingAttributeType["NosAmount"] = "NOS_AMOUNT";
    MarketingAttributeType["OpeningBid"] = "OPENING_BID";
    MarketingAttributeType["OriginalPrincipalBalance"] = "ORIGINAL_PRINCIPAL_BALANCE";
    MarketingAttributeType["RemoteBid"] = "REMOTE_BID";
    MarketingAttributeType["RemoteBidBeforeAndDuringAuction"] = "REMOTE_BID_BEFORE_AND_DURING_AUCTION";
    MarketingAttributeType["ReserveAmount"] = "RESERVE_AMOUNT";
    MarketingAttributeType["SalesAgentContact"] = "SALES_AGENT_CONTACT";
    MarketingAttributeType["SecondPaymentVerbiage"] = "SECOND_PAYMENT_VERBIAGE";
    MarketingAttributeType["SellerDisclosure"] = "SELLER_DISCLOSURE";
    MarketingAttributeType["StateDepositBalanceDueVerbiage"] = "STATE_DEPOSIT_BALANCE_DUE_VERBIAGE";
    MarketingAttributeType["TransactionDetails"] = "TRANSACTION_DETAILS";
    MarketingAttributeType["TrusteeSaleNumber"] = "TRUSTEE_SALE_NUMBER";
})(MarketingAttributeType || (MarketingAttributeType = {}));
var MarketingAvailableStatus;
(function (MarketingAvailableStatus) {
    MarketingAvailableStatus["MarketingAvailCleared"] = "MARKETING_AVAIL_CLEARED";
    MarketingAvailableStatus["MarketingAvailNotCleared"] = "MARKETING_AVAIL_NOT_CLEARED";
})(MarketingAvailableStatus || (MarketingAvailableStatus = {}));
var MediaPurposeType;
(function (MediaPurposeType) {
    MediaPurposeType["BrokerPriceOpinion"] = "BROKER_PRICE_OPINION";
    MediaPurposeType["InspectionReport"] = "INSPECTION_REPORT";
    MediaPurposeType["PreliminaryTitleReport"] = "PRELIMINARY_TITLE_REPORT";
    MediaPurposeType["RedactedBrokerPriceOpinion"] = "REDACTED_BROKER_PRICE_OPINION";
})(MediaPurposeType || (MediaPurposeType = {}));
var MediaType;
(function (MediaType) {
    MediaType["Document"] = "DOCUMENT";
    MediaType["Image"] = "IMAGE";
})(MediaType || (MediaType = {}));
var MediaUsageTypeCode;
(function (MediaUsageTypeCode) {
    MediaUsageTypeCode["Internal"] = "INTERNAL";
    MediaUsageTypeCode["Live"] = "LIVE";
    MediaUsageTypeCode["Marketing"] = "MARKETING";
    MediaUsageTypeCode["Web"] = "WEB";
})(MediaUsageTypeCode || (MediaUsageTypeCode = {}));
var MlhSyncStatus;
(function (MlhSyncStatus) {
    MlhSyncStatus["Error"] = "ERROR";
    MlhSyncStatus["Info"] = "INFO";
    MlhSyncStatus["Success"] = "SUCCESS";
})(MlhSyncStatus || (MlhSyncStatus = {}));
var MobileOperatingSystem;
(function (MobileOperatingSystem) {
    MobileOperatingSystem["Android"] = "ANDROID";
    MobileOperatingSystem["Ios"] = "IOS";
})(MobileOperatingSystem || (MobileOperatingSystem = {}));
var NoteUpdateReason;
(function (NoteUpdateReason) {
    NoteUpdateReason["AuctioneerOverwrite"] = "AUCTIONEER_OVERWRITE";
    NoteUpdateReason["BuyerUpdate"] = "BUYER_UPDATE";
})(NoteUpdateReason || (NoteUpdateReason = {}));
var NotificationCategoryCode;
(function (NotificationCategoryCode) {
    NotificationCategoryCode["AccountSetup"] = "ACCOUNT_SETUP";
    NotificationCategoryCode["Bidding"] = "BIDDING";
    NotificationCategoryCode["Closing"] = "CLOSING";
    NotificationCategoryCode["Contracting"] = "CONTRACTING";
    NotificationCategoryCode["Marketing"] = "MARKETING";
})(NotificationCategoryCode || (NotificationCategoryCode = {}));
var NotificationChannelType;
(function (NotificationChannelType) {
    NotificationChannelType["Email"] = "EMAIL";
    NotificationChannelType["External"] = "EXTERNAL";
    NotificationChannelType["Sms"] = "SMS";
    NotificationChannelType["TwilioStudio"] = "TWILIO_STUDIO";
    NotificationChannelType["Web"] = "WEB";
})(NotificationChannelType || (NotificationChannelType = {}));
var NotificationIntentCode;
(function (NotificationIntentCode) {
    NotificationIntentCode["ActionNeeded"] = "ACTION_NEEDED";
    NotificationIntentCode["ActionRequested"] = "ACTION_REQUESTED";
    NotificationIntentCode["OutcomeNegative"] = "OUTCOME_NEGATIVE";
    NotificationIntentCode["OutcomePositive"] = "OUTCOME_POSITIVE";
})(NotificationIntentCode || (NotificationIntentCode = {}));
var OtpDeliveryMechanism;
(function (OtpDeliveryMechanism) {
    OtpDeliveryMechanism["Call"] = "CALL";
    OtpDeliveryMechanism["Sms"] = "SMS";
})(OtpDeliveryMechanism || (OtpDeliveryMechanism = {}));
var ObjectChangeReviewStatus;
(function (ObjectChangeReviewStatus) {
    ObjectChangeReviewStatus["Accepted"] = "ACCEPTED";
    ObjectChangeReviewStatus["Canceled"] = "CANCELED";
    ObjectChangeReviewStatus["Failed"] = "FAILED";
    ObjectChangeReviewStatus["Pending"] = "PENDING";
    ObjectChangeReviewStatus["Rejected"] = "REJECTED";
})(ObjectChangeReviewStatus || (ObjectChangeReviewStatus = {}));
var OccupancyDescriptionType;
(function (OccupancyDescriptionType) {
    OccupancyDescriptionType["AdverselyOccupied"] = "ADVERSELY_OCCUPIED";
    OccupancyDescriptionType["OwnerOccupied"] = "OWNER_OCCUPIED";
    OccupancyDescriptionType["TenantOccupied"] = "TENANT_OCCUPIED";
    OccupancyDescriptionType["Vacant"] = "VACANT";
})(OccupancyDescriptionType || (OccupancyDescriptionType = {}));
var OccupancyStatus;
(function (OccupancyStatus) {
    OccupancyStatus["Occupied"] = "OCCUPIED";
    OccupancyStatus["Unknown"] = "UNKNOWN";
    OccupancyStatus["Vacant"] = "VACANT";
})(OccupancyStatus || (OccupancyStatus = {}));
var OccupancyType;
(function (OccupancyType) {
    OccupancyType["Investor"] = "INVESTOR";
    OccupancyType["NonProfit"] = "NON_PROFIT";
    OccupancyType["NotDisclosed"] = "NOT_DISCLOSED";
    OccupancyType["Owner"] = "OWNER";
    OccupancyType["SecondHome"] = "SECOND_HOME";
    OccupancyType["ToBeDetermined"] = "TO_BE_DETERMINED";
})(OccupancyType || (OccupancyType = {}));
var OfferorType;
(function (OfferorType) {
    OfferorType["Buyer"] = "BUYER";
    OfferorType["BuyersAgent"] = "BUYERS_AGENT";
    OfferorType["ListingAgent"] = "LISTING_AGENT";
})(OfferorType || (OfferorType = {}));
var OnlineAuctionPersonaType;
(function (OnlineAuctionPersonaType) {
    OnlineAuctionPersonaType["Bidder"] = "BIDDER";
    OnlineAuctionPersonaType["Buyer"] = "BUYER";
    OnlineAuctionPersonaType["Novice"] = "NOVICE";
})(OnlineAuctionPersonaType || (OnlineAuctionPersonaType = {}));
var OnlineAuctionSegmentBidRankingVisibilityLevel;
(function (OnlineAuctionSegmentBidRankingVisibilityLevel) {
    OnlineAuctionSegmentBidRankingVisibilityLevel["AllowHigher"] = "ALLOW_HIGHER";
    OnlineAuctionSegmentBidRankingVisibilityLevel["AllowHigherOrEqual"] = "ALLOW_HIGHER_OR_EQUAL";
    OnlineAuctionSegmentBidRankingVisibilityLevel["Participants"] = "PARTICIPANTS";
    OnlineAuctionSegmentBidRankingVisibilityLevel["Public"] = "PUBLIC";
})(OnlineAuctionSegmentBidRankingVisibilityLevel || (OnlineAuctionSegmentBidRankingVisibilityLevel = {}));
var OnlineAuctionSegmentBidType;
(function (OnlineAuctionSegmentBidType) {
    OnlineAuctionSegmentBidType["BuyerCounterBid"] = "BUYER_COUNTER_BID";
    OnlineAuctionSegmentBidType["Manual"] = "MANUAL";
    OnlineAuctionSegmentBidType["Match"] = "MATCH";
    OnlineAuctionSegmentBidType["MaxBid"] = "MAX_BID";
    OnlineAuctionSegmentBidType["Regular"] = "REGULAR";
    OnlineAuctionSegmentBidType["Seller"] = "SELLER";
    OnlineAuctionSegmentBidType["SellerCounterBid"] = "SELLER_COUNTER_BID";
    OnlineAuctionSegmentBidType["TraditionalOffer"] = "TRADITIONAL_OFFER";
})(OnlineAuctionSegmentBidType || (OnlineAuctionSegmentBidType = {}));
var OnlineAuctionSegmentBiddingStatus;
(function (OnlineAuctionSegmentBiddingStatus) {
    OnlineAuctionSegmentBiddingStatus["HighestBid"] = "HIGHEST_BID";
    OnlineAuctionSegmentBiddingStatus["Lost"] = "LOST";
    OnlineAuctionSegmentBiddingStatus["NoBid"] = "NO_BID";
    OnlineAuctionSegmentBiddingStatus["Outbid"] = "OUTBID";
    OnlineAuctionSegmentBiddingStatus["RejectedBid"] = "REJECTED_BID";
    OnlineAuctionSegmentBiddingStatus["WithdrawnBid"] = "WITHDRAWN_BID";
    OnlineAuctionSegmentBiddingStatus["Won"] = "WON";
})(OnlineAuctionSegmentBiddingStatus || (OnlineAuctionSegmentBiddingStatus = {}));
var OnlineAuctionSegmentStatus;
(function (OnlineAuctionSegmentStatus) {
    OnlineAuctionSegmentStatus["Ended"] = "ENDED";
    OnlineAuctionSegmentStatus["HighestAndBestDecision"] = "HIGHEST_AND_BEST_DECISION";
    OnlineAuctionSegmentStatus["HighestAndBestOpen"] = "HIGHEST_AND_BEST_OPEN";
    OnlineAuctionSegmentStatus["Pending"] = "PENDING";
    OnlineAuctionSegmentStatus["ReserveMet"] = "RESERVE_MET";
    OnlineAuctionSegmentStatus["SellerReviewPeriod"] = "SELLER_REVIEW_PERIOD";
    OnlineAuctionSegmentStatus["Started"] = "STARTED";
    OnlineAuctionSegmentStatus["SubjectToReserveMet"] = "SUBJECT_TO_RESERVE_MET";
})(OnlineAuctionSegmentStatus || (OnlineAuctionSegmentStatus = {}));
var OnlineAuctionSegmentType;
(function (OnlineAuctionSegmentType) {
    OnlineAuctionSegmentType["English"] = "ENGLISH";
    OnlineAuctionSegmentType["SealedBid"] = "SEALED_BID";
})(OnlineAuctionSegmentType || (OnlineAuctionSegmentType = {}));
var OnlineAuctionSegmentUpdateSource;
(function (OnlineAuctionSegmentUpdateSource) {
    OnlineAuctionSegmentUpdateSource["ListingPortal"] = "LISTING_PORTAL";
    OnlineAuctionSegmentUpdateSource["Morpheus"] = "MORPHEUS";
    OnlineAuctionSegmentUpdateSource["Pibi"] = "PIBI";
    OnlineAuctionSegmentUpdateSource["QualDash"] = "QUAL_DASH";
})(OnlineAuctionSegmentUpdateSource || (OnlineAuctionSegmentUpdateSource = {}));
var OnlineBidDepositRefundBlockReason;
(function (OnlineBidDepositRefundBlockReason) {
    OnlineBidDepositRefundBlockReason["ActiveBid"] = "ACTIVE_BID";
    OnlineBidDepositRefundBlockReason["ContractInProgress"] = "CONTRACT_IN_PROGRESS";
    OnlineBidDepositRefundBlockReason["QualityBid"] = "QUALITY_BID";
    OnlineBidDepositRefundBlockReason["ReserveMet"] = "RESERVE_MET";
    OnlineBidDepositRefundBlockReason["SubjectToReserveMet"] = "SUBJECT_TO_RESERVE_MET";
})(OnlineBidDepositRefundBlockReason || (OnlineBidDepositRefundBlockReason = {}));
var OnlineBidDepositRefundConsequence;
(function (OnlineBidDepositRefundConsequence) {
    OnlineBidDepositRefundConsequence["BidDeletion"] = "BID_DELETION";
    OnlineBidDepositRefundConsequence["Unregister"] = "UNREGISTER";
})(OnlineBidDepositRefundConsequence || (OnlineBidDepositRefundConsequence = {}));
var OnlineBidHistoryEntryActionType;
(function (OnlineBidHistoryEntryActionType) {
    OnlineBidHistoryEntryActionType["Create"] = "CREATE";
    OnlineBidHistoryEntryActionType["Delete"] = "DELETE";
    OnlineBidHistoryEntryActionType["Update"] = "UPDATE";
})(OnlineBidHistoryEntryActionType || (OnlineBidHistoryEntryActionType = {}));
var OnlineRegistrationStatus;
(function (OnlineRegistrationStatus) {
    OnlineRegistrationStatus["Approved"] = "APPROVED";
    OnlineRegistrationStatus["PendingDepositConfirmation"] = "PENDING_DEPOSIT_CONFIRMATION";
    OnlineRegistrationStatus["Suspended"] = "SUSPENDED";
})(OnlineRegistrationStatus || (OnlineRegistrationStatus = {}));
var OnlineSegmentExtensionReason;
(function (OnlineSegmentExtensionReason) {
    OnlineSegmentExtensionReason["AntiBidSnipe"] = "ANTI_BID_SNIPE";
    OnlineSegmentExtensionReason["AuctioneerDiscretion"] = "AUCTIONEER_DISCRETION";
    OnlineSegmentExtensionReason["BidAgain"] = "BID_AGAIN";
    OnlineSegmentExtensionReason["HighestAndBestDecision"] = "HIGHEST_AND_BEST_DECISION";
    OnlineSegmentExtensionReason["HighestAndBestOpen"] = "HIGHEST_AND_BEST_OPEN";
    OnlineSegmentExtensionReason["HighBidder"] = "HIGH_BIDDER";
    OnlineSegmentExtensionReason["ListingChange"] = "LISTING_CHANGE";
    OnlineSegmentExtensionReason["PendingSellerConfirmation"] = "PENDING_SELLER_CONFIRMATION";
    OnlineSegmentExtensionReason["SellerReviewPeriodEnd"] = "SELLER_REVIEW_PERIOD_END";
    OnlineSegmentExtensionReason["SellerReviewPeriodStart"] = "SELLER_REVIEW_PERIOD_START";
})(OnlineSegmentExtensionReason || (OnlineSegmentExtensionReason = {}));
var OnlineSegmentExtensionType;
(function (OnlineSegmentExtensionType) {
    OnlineSegmentExtensionType["Automated"] = "AUTOMATED";
    OnlineSegmentExtensionType["Manual"] = "MANUAL";
})(OnlineSegmentExtensionType || (OnlineSegmentExtensionType = {}));
var Origin;
(function (Origin) {
    Origin["Attorney"] = "ATTORNEY";
    Origin["AuctionSync"] = "AUCTION_SYNC";
    Origin["BiddingEngine"] = "BIDDING_ENGINE";
    Origin["Mlh"] = "MLH";
    Origin["Morpheus"] = "MORPHEUS";
    Origin["RealAuction"] = "REAL_AUCTION";
    Origin["Strategy"] = "STRATEGY";
    Origin["Trinity"] = "TRINITY";
    Origin["TrusteeWebService"] = "TRUSTEE_WEB_SERVICE";
})(Origin || (Origin = {}));
var PartyAuthorizationAction;
(function (PartyAuthorizationAction) {
    PartyAuthorizationAction["EditPhone"] = "EDIT_PHONE";
})(PartyAuthorizationAction || (PartyAuthorizationAction = {}));
var PartyBiddingStatus;
(function (PartyBiddingStatus) {
    PartyBiddingStatus["HighestBid"] = "HIGHEST_BID";
    PartyBiddingStatus["NoBid"] = "NO_BID";
    PartyBiddingStatus["Outbid"] = "OUTBID";
})(PartyBiddingStatus || (PartyBiddingStatus = {}));
var PayableTo;
(function (PayableTo) {
    PayableTo["Adc"] = "ADC";
    PayableTo["Other"] = "OTHER";
    PayableTo["Trustee"] = "TRUSTEE";
})(PayableTo || (PayableTo = {}));
var PaymentFailureReason;
(function (PaymentFailureReason) {
    PaymentFailureReason["AccountClosed"] = "ACCOUNT_CLOSED";
    PaymentFailureReason["AccountCountryInvalidAddress"] = "ACCOUNT_COUNTRY_INVALID_ADDRESS";
    PaymentFailureReason["AccountErrorCountryChangeRequiresAdditionalSteps"] = "ACCOUNT_ERROR_COUNTRY_CHANGE_REQUIRES_ADDITIONAL_STEPS";
    PaymentFailureReason["AccountInformationMismatch"] = "ACCOUNT_INFORMATION_MISMATCH";
    PaymentFailureReason["AccountInvalid"] = "ACCOUNT_INVALID";
    PaymentFailureReason["AccountNumberInvalid"] = "ACCOUNT_NUMBER_INVALID";
    PaymentFailureReason["AcssDebitSessionIncomplete"] = "ACSS_DEBIT_SESSION_INCOMPLETE";
    PaymentFailureReason["AlipayUpgradeRequired"] = "ALIPAY_UPGRADE_REQUIRED";
    PaymentFailureReason["AmountTooLarge"] = "AMOUNT_TOO_LARGE";
    PaymentFailureReason["AmountTooSmall"] = "AMOUNT_TOO_SMALL";
    PaymentFailureReason["ApiKeyExpired"] = "API_KEY_EXPIRED";
    PaymentFailureReason["ApplicationFeesNotAllowed"] = "APPLICATION_FEES_NOT_ALLOWED";
    PaymentFailureReason["ApproveWithId"] = "APPROVE_WITH_ID";
    PaymentFailureReason["AuthenticationRequired"] = "AUTHENTICATION_REQUIRED";
    PaymentFailureReason["BalanceInsufficient"] = "BALANCE_INSUFFICIENT";
    PaymentFailureReason["BalanceInvalidParameter"] = "BALANCE_INVALID_PARAMETER";
    PaymentFailureReason["BankAccountBadRoutingNumbers"] = "BANK_ACCOUNT_BAD_ROUTING_NUMBERS";
    PaymentFailureReason["BankAccountDeclined"] = "BANK_ACCOUNT_DECLINED";
    PaymentFailureReason["BankAccountExists"] = "BANK_ACCOUNT_EXISTS";
    PaymentFailureReason["BankAccountRestricted"] = "BANK_ACCOUNT_RESTRICTED";
    PaymentFailureReason["BankAccountUnusable"] = "BANK_ACCOUNT_UNUSABLE";
    PaymentFailureReason["BankAccountUnverified"] = "BANK_ACCOUNT_UNVERIFIED";
    PaymentFailureReason["BankAccountVerificationFailed"] = "BANK_ACCOUNT_VERIFICATION_FAILED";
    PaymentFailureReason["BillingInvalidMandate"] = "BILLING_INVALID_MANDATE";
    PaymentFailureReason["BitcoinUpgradeRequired"] = "BITCOIN_UPGRADE_REQUIRED";
    PaymentFailureReason["CallIssuer"] = "CALL_ISSUER";
    PaymentFailureReason["CaptureChargeAuthorizationExpired"] = "CAPTURE_CHARGE_AUTHORIZATION_EXPIRED";
    PaymentFailureReason["CaptureUnauthorizedPayment"] = "CAPTURE_UNAUTHORIZED_PAYMENT";
    PaymentFailureReason["CardholderPhoneNumberRequired"] = "CARDHOLDER_PHONE_NUMBER_REQUIRED";
    PaymentFailureReason["CardDeclined"] = "CARD_DECLINED";
    PaymentFailureReason["CardDeclineRateLimitExceeded"] = "CARD_DECLINE_RATE_LIMIT_EXCEEDED";
    PaymentFailureReason["CardNotSupported"] = "CARD_NOT_SUPPORTED";
    PaymentFailureReason["CardVelocityExceeded"] = "CARD_VELOCITY_EXCEEDED";
    PaymentFailureReason["ChargeAlreadyCaptured"] = "CHARGE_ALREADY_CAPTURED";
    PaymentFailureReason["ChargeAlreadyRefunded"] = "CHARGE_ALREADY_REFUNDED";
    PaymentFailureReason["ChargeDisputed"] = "CHARGE_DISPUTED";
    PaymentFailureReason["ChargeExceedsSourceLimit"] = "CHARGE_EXCEEDS_SOURCE_LIMIT";
    PaymentFailureReason["ChargeExceedsTransactionLimit"] = "CHARGE_EXCEEDS_TRANSACTION_LIMIT";
    PaymentFailureReason["ChargeExpiredForCapture"] = "CHARGE_EXPIRED_FOR_CAPTURE";
    PaymentFailureReason["ChargeInvalidParameter"] = "CHARGE_INVALID_PARAMETER";
    PaymentFailureReason["ChargeNotRefundable"] = "CHARGE_NOT_REFUNDABLE";
    PaymentFailureReason["ClearingCodeUnsupported"] = "CLEARING_CODE_UNSUPPORTED";
    PaymentFailureReason["CountryCodeInvalid"] = "COUNTRY_CODE_INVALID";
    PaymentFailureReason["CountryUnsupported"] = "COUNTRY_UNSUPPORTED";
    PaymentFailureReason["CouponExpired"] = "COUPON_EXPIRED";
    PaymentFailureReason["CurrencyNotSupported"] = "CURRENCY_NOT_SUPPORTED";
    PaymentFailureReason["CustomerMaxPaymentMethods"] = "CUSTOMER_MAX_PAYMENT_METHODS";
    PaymentFailureReason["CustomerMaxSubscriptions"] = "CUSTOMER_MAX_SUBSCRIPTIONS";
    PaymentFailureReason["CustomerTaxLocationInvalid"] = "CUSTOMER_TAX_LOCATION_INVALID";
    PaymentFailureReason["DebitNotAuthorized"] = "DEBIT_NOT_AUTHORIZED";
    PaymentFailureReason["DoNotHonor"] = "DO_NOT_HONOR";
    PaymentFailureReason["DoNotTryAgain"] = "DO_NOT_TRY_AGAIN";
    PaymentFailureReason["DuplicateTransaction"] = "DUPLICATE_TRANSACTION";
    PaymentFailureReason["EmailInvalid"] = "EMAIL_INVALID";
    PaymentFailureReason["ExpiredCard"] = "EXPIRED_CARD";
    PaymentFailureReason["FinancialConnectionsAccountInactive"] = "FINANCIAL_CONNECTIONS_ACCOUNT_INACTIVE";
    PaymentFailureReason["FinancialConnectionsNoSuccessfulTransactionRefresh"] = "FINANCIAL_CONNECTIONS_NO_SUCCESSFUL_TRANSACTION_REFRESH";
    PaymentFailureReason["ForwardingApiInactive"] = "FORWARDING_API_INACTIVE";
    PaymentFailureReason["ForwardingApiInvalidParameter"] = "FORWARDING_API_INVALID_PARAMETER";
    PaymentFailureReason["ForwardingApiUpstreamConnectionError"] = "FORWARDING_API_UPSTREAM_CONNECTION_ERROR";
    PaymentFailureReason["ForwardingApiUpstreamConnectionTimeout"] = "FORWARDING_API_UPSTREAM_CONNECTION_TIMEOUT";
    PaymentFailureReason["Fraudulent"] = "FRAUDULENT";
    PaymentFailureReason["GenericDecline"] = "GENERIC_DECLINE";
    PaymentFailureReason["IdempotencyKeyInUse"] = "IDEMPOTENCY_KEY_IN_USE";
    PaymentFailureReason["IncorrectAddress"] = "INCORRECT_ADDRESS";
    PaymentFailureReason["IncorrectCvc"] = "INCORRECT_CVC";
    PaymentFailureReason["IncorrectNumber"] = "INCORRECT_NUMBER";
    PaymentFailureReason["IncorrectPin"] = "INCORRECT_PIN";
    PaymentFailureReason["IncorrectZip"] = "INCORRECT_ZIP";
    PaymentFailureReason["InstantPayoutsConfigDisabled"] = "INSTANT_PAYOUTS_CONFIG_DISABLED";
    PaymentFailureReason["InstantPayoutsCurrencyDisabled"] = "INSTANT_PAYOUTS_CURRENCY_DISABLED";
    PaymentFailureReason["InstantPayoutsLimitExceeded"] = "INSTANT_PAYOUTS_LIMIT_EXCEEDED";
    PaymentFailureReason["InstantPayoutsUnsupported"] = "INSTANT_PAYOUTS_UNSUPPORTED";
    PaymentFailureReason["InsufficientFunds"] = "INSUFFICIENT_FUNDS";
    PaymentFailureReason["IntentInvalidState"] = "INTENT_INVALID_STATE";
    PaymentFailureReason["IntentVerificationMethodMissing"] = "INTENT_VERIFICATION_METHOD_MISSING";
    PaymentFailureReason["InvalidAccount"] = "INVALID_ACCOUNT";
    PaymentFailureReason["InvalidAmount"] = "INVALID_AMOUNT";
    PaymentFailureReason["InvalidCardType"] = "INVALID_CARD_TYPE";
    PaymentFailureReason["InvalidCharacters"] = "INVALID_CHARACTERS";
    PaymentFailureReason["InvalidChargeAmount"] = "INVALID_CHARGE_AMOUNT";
    PaymentFailureReason["InvalidCvc"] = "INVALID_CVC";
    PaymentFailureReason["InvalidExpiryMonth"] = "INVALID_EXPIRY_MONTH";
    PaymentFailureReason["InvalidExpiryYear"] = "INVALID_EXPIRY_YEAR";
    PaymentFailureReason["InvalidMandateReferencePrefixFormat"] = "INVALID_MANDATE_REFERENCE_PREFIX_FORMAT";
    PaymentFailureReason["InvalidNumber"] = "INVALID_NUMBER";
    PaymentFailureReason["InvalidPin"] = "INVALID_PIN";
    PaymentFailureReason["InvalidSourceUsage"] = "INVALID_SOURCE_USAGE";
    PaymentFailureReason["InvalidTaxLocation"] = "INVALID_TAX_LOCATION";
    PaymentFailureReason["InvoiceNotEditable"] = "INVOICE_NOT_EDITABLE";
    PaymentFailureReason["InvoiceNoCustomerLineItems"] = "INVOICE_NO_CUSTOMER_LINE_ITEMS";
    PaymentFailureReason["InvoiceNoPaymentMethodTypes"] = "INVOICE_NO_PAYMENT_METHOD_TYPES";
    PaymentFailureReason["InvoiceNoSubscriptionLineItems"] = "INVOICE_NO_SUBSCRIPTION_LINE_ITEMS";
    PaymentFailureReason["InvoiceOnBehalfOfNotEditable"] = "INVOICE_ON_BEHALF_OF_NOT_EDITABLE";
    PaymentFailureReason["InvoicePaymentIntentRequiresAction"] = "INVOICE_PAYMENT_INTENT_REQUIRES_ACTION";
    PaymentFailureReason["InvoiceUpcomingNone"] = "INVOICE_UPCOMING_NONE";
    PaymentFailureReason["IssuerNotAvailable"] = "ISSUER_NOT_AVAILABLE";
    PaymentFailureReason["LivemodeMismatch"] = "LIVEMODE_MISMATCH";
    PaymentFailureReason["LockTimeout"] = "LOCK_TIMEOUT";
    PaymentFailureReason["LostCard"] = "LOST_CARD";
    PaymentFailureReason["MerchantBlacklist"] = "MERCHANT_BLACKLIST";
    PaymentFailureReason["Missing"] = "MISSING";
    PaymentFailureReason["NewAccountInformationAvailable"] = "NEW_ACCOUNT_INFORMATION_AVAILABLE";
    PaymentFailureReason["NotAllowedOnStandardAccount"] = "NOT_ALLOWED_ON_STANDARD_ACCOUNT";
    PaymentFailureReason["NotPermitted"] = "NOT_PERMITTED";
    PaymentFailureReason["NoAccount"] = "NO_ACCOUNT";
    PaymentFailureReason["NoActionTaken"] = "NO_ACTION_TAKEN";
    PaymentFailureReason["OfflinePinRequired"] = "OFFLINE_PIN_REQUIRED";
    PaymentFailureReason["OnlineOrOfflinePinRequired"] = "ONLINE_OR_OFFLINE_PIN_REQUIRED";
    PaymentFailureReason["OutOfInventory"] = "OUT_OF_INVENTORY";
    PaymentFailureReason["OwnershipDeclarationNotAllowed"] = "OWNERSHIP_DECLARATION_NOT_ALLOWED";
    PaymentFailureReason["ParametersExclusive"] = "PARAMETERS_EXCLUSIVE";
    PaymentFailureReason["ParameterInvalidEmpty"] = "PARAMETER_INVALID_EMPTY";
    PaymentFailureReason["ParameterInvalidInteger"] = "PARAMETER_INVALID_INTEGER";
    PaymentFailureReason["ParameterInvalidStringBlank"] = "PARAMETER_INVALID_STRING_BLANK";
    PaymentFailureReason["ParameterInvalidStringEmpty"] = "PARAMETER_INVALID_STRING_EMPTY";
    PaymentFailureReason["ParameterMissing"] = "PARAMETER_MISSING";
    PaymentFailureReason["ParameterUnknown"] = "PARAMETER_UNKNOWN";
    PaymentFailureReason["PaymentIntentActionRequired"] = "PAYMENT_INTENT_ACTION_REQUIRED";
    PaymentFailureReason["PaymentIntentAuthenticationFailure"] = "PAYMENT_INTENT_AUTHENTICATION_FAILURE";
    PaymentFailureReason["PaymentIntentIncompatiblePaymentMethod"] = "PAYMENT_INTENT_INCOMPATIBLE_PAYMENT_METHOD";
    PaymentFailureReason["PaymentIntentInvalidParameter"] = "PAYMENT_INTENT_INVALID_PARAMETER";
    PaymentFailureReason["PaymentIntentKonbiniRejectedConfirmationNumber"] = "PAYMENT_INTENT_KONBINI_REJECTED_CONFIRMATION_NUMBER";
    PaymentFailureReason["PaymentIntentMandateInvalid"] = "PAYMENT_INTENT_MANDATE_INVALID";
    PaymentFailureReason["PaymentIntentPaymentAttemptExpired"] = "PAYMENT_INTENT_PAYMENT_ATTEMPT_EXPIRED";
    PaymentFailureReason["PaymentIntentPaymentAttemptFailed"] = "PAYMENT_INTENT_PAYMENT_ATTEMPT_FAILED";
    PaymentFailureReason["PaymentIntentUnexpectedState"] = "PAYMENT_INTENT_UNEXPECTED_STATE";
    PaymentFailureReason["PaymentMethodBankAccountAlreadyVerified"] = "PAYMENT_METHOD_BANK_ACCOUNT_ALREADY_VERIFIED";
    PaymentFailureReason["PaymentMethodBankAccountBlocked"] = "PAYMENT_METHOD_BANK_ACCOUNT_BLOCKED";
    PaymentFailureReason["PaymentMethodBillingDetailsAddressMissing"] = "PAYMENT_METHOD_BILLING_DETAILS_ADDRESS_MISSING";
    PaymentFailureReason["PaymentMethodConfigurationFailures"] = "PAYMENT_METHOD_CONFIGURATION_FAILURES";
    PaymentFailureReason["PaymentMethodCurrencyMismatch"] = "PAYMENT_METHOD_CURRENCY_MISMATCH";
    PaymentFailureReason["PaymentMethodCustomerDecline"] = "PAYMENT_METHOD_CUSTOMER_DECLINE";
    PaymentFailureReason["PaymentMethodInvalidParameter"] = "PAYMENT_METHOD_INVALID_PARAMETER";
    PaymentFailureReason["PaymentMethodInvalidParameterTestmode"] = "PAYMENT_METHOD_INVALID_PARAMETER_TESTMODE";
    PaymentFailureReason["PaymentMethodMicrodepositFailed"] = "PAYMENT_METHOD_MICRODEPOSIT_FAILED";
    PaymentFailureReason["PaymentMethodMicrodepositVerificationAmountsInvalid"] = "PAYMENT_METHOD_MICRODEPOSIT_VERIFICATION_AMOUNTS_INVALID";
    PaymentFailureReason["PaymentMethodMicrodepositVerificationAmountsMismatch"] = "PAYMENT_METHOD_MICRODEPOSIT_VERIFICATION_AMOUNTS_MISMATCH";
    PaymentFailureReason["PaymentMethodMicrodepositVerificationAttemptsExceeded"] = "PAYMENT_METHOD_MICRODEPOSIT_VERIFICATION_ATTEMPTS_EXCEEDED";
    PaymentFailureReason["PaymentMethodMicrodepositVerificationDescriptorCodeMismatch"] = "PAYMENT_METHOD_MICRODEPOSIT_VERIFICATION_DESCRIPTOR_CODE_MISMATCH";
    PaymentFailureReason["PaymentMethodMicrodepositVerificationTimeout"] = "PAYMENT_METHOD_MICRODEPOSIT_VERIFICATION_TIMEOUT";
    PaymentFailureReason["PaymentMethodNotAvailable"] = "PAYMENT_METHOD_NOT_AVAILABLE";
    PaymentFailureReason["PaymentMethodProviderDecline"] = "PAYMENT_METHOD_PROVIDER_DECLINE";
    PaymentFailureReason["PaymentMethodProviderTimeout"] = "PAYMENT_METHOD_PROVIDER_TIMEOUT";
    PaymentFailureReason["PaymentMethodUnactivated"] = "PAYMENT_METHOD_UNACTIVATED";
    PaymentFailureReason["PaymentMethodUnexpectedState"] = "PAYMENT_METHOD_UNEXPECTED_STATE";
    PaymentFailureReason["PaymentMethodUnsupportedType"] = "PAYMENT_METHOD_UNSUPPORTED_TYPE";
    PaymentFailureReason["PayoutsLimitExceeded"] = "PAYOUTS_LIMIT_EXCEEDED";
    PaymentFailureReason["PayoutsNotAllowed"] = "PAYOUTS_NOT_ALLOWED";
    PaymentFailureReason["PayoutReconciliationNotReady"] = "PAYOUT_RECONCILIATION_NOT_READY";
    PaymentFailureReason["PickupCard"] = "PICKUP_CARD";
    PaymentFailureReason["PinTryExceeded"] = "PIN_TRY_EXCEEDED";
    PaymentFailureReason["PlatformAccountRequired"] = "PLATFORM_ACCOUNT_REQUIRED";
    PaymentFailureReason["PlatformApiKeyExpired"] = "PLATFORM_API_KEY_EXPIRED";
    PaymentFailureReason["PostalCodeInvalid"] = "POSTAL_CODE_INVALID";
    PaymentFailureReason["ProcessingError"] = "PROCESSING_ERROR";
    PaymentFailureReason["ProductInactive"] = "PRODUCT_INACTIVE";
    PaymentFailureReason["ProgressiveOnboardingLimitExceeded"] = "PROGRESSIVE_ONBOARDING_LIMIT_EXCEEDED";
    PaymentFailureReason["RateLimit"] = "RATE_LIMIT";
    PaymentFailureReason["ReenterTransaction"] = "REENTER_TRANSACTION";
    PaymentFailureReason["ReferToCustomer"] = "REFER_TO_CUSTOMER";
    PaymentFailureReason["RefundDisputedPayment"] = "REFUND_DISPUTED_PAYMENT";
    PaymentFailureReason["ResourceAlreadyExists"] = "RESOURCE_ALREADY_EXISTS";
    PaymentFailureReason["ResourceMissing"] = "RESOURCE_MISSING";
    PaymentFailureReason["RestrictedCard"] = "RESTRICTED_CARD";
    PaymentFailureReason["ReturnIntentAlreadyProcessed"] = "RETURN_INTENT_ALREADY_PROCESSED";
    PaymentFailureReason["RevocationOfAllAuthorizations"] = "REVOCATION_OF_ALL_AUTHORIZATIONS";
    PaymentFailureReason["RevocationOfAuthorization"] = "REVOCATION_OF_AUTHORIZATION";
    PaymentFailureReason["RoutingNumberInvalid"] = "ROUTING_NUMBER_INVALID";
    PaymentFailureReason["SecretKeyRequired"] = "SECRET_KEY_REQUIRED";
    PaymentFailureReason["SecurityViolation"] = "SECURITY_VIOLATION";
    PaymentFailureReason["SepaUnsupportedAccount"] = "SEPA_UNSUPPORTED_ACCOUNT";
    PaymentFailureReason["ServiceNotAllowed"] = "SERVICE_NOT_ALLOWED";
    PaymentFailureReason["SetupAttemptFailed"] = "SETUP_ATTEMPT_FAILED";
    PaymentFailureReason["SetupIntentAuthenticationFailure"] = "SETUP_INTENT_AUTHENTICATION_FAILURE";
    PaymentFailureReason["SetupIntentInvalidParameter"] = "SETUP_INTENT_INVALID_PARAMETER";
    PaymentFailureReason["SetupIntentMandateInvalid"] = "SETUP_INTENT_MANDATE_INVALID";
    PaymentFailureReason["SetupIntentSetupAttemptExpired"] = "SETUP_INTENT_SETUP_ATTEMPT_EXPIRED";
    PaymentFailureReason["SetupIntentUnexpectedState"] = "SETUP_INTENT_UNEXPECTED_STATE";
    PaymentFailureReason["ShippingAddressInvalid"] = "SHIPPING_ADDRESS_INVALID";
    PaymentFailureReason["ShippingCalculationFailed"] = "SHIPPING_CALCULATION_FAILED";
    PaymentFailureReason["SkuInactive"] = "SKU_INACTIVE";
    PaymentFailureReason["StateUnsupported"] = "STATE_UNSUPPORTED";
    PaymentFailureReason["StatusTransitionInvalid"] = "STATUS_TRANSITION_INVALID";
    PaymentFailureReason["StolenCard"] = "STOLEN_CARD";
    PaymentFailureReason["StopPaymentOrder"] = "STOP_PAYMENT_ORDER";
    PaymentFailureReason["StripeTaxInactive"] = "STRIPE_TAX_INACTIVE";
    PaymentFailureReason["TaxesCalculationFailed"] = "TAXES_CALCULATION_FAILED";
    PaymentFailureReason["TaxIdInvalid"] = "TAX_ID_INVALID";
    PaymentFailureReason["TerminalLocationCountryUnsupported"] = "TERMINAL_LOCATION_COUNTRY_UNSUPPORTED";
    PaymentFailureReason["TerminalReaderBusy"] = "TERMINAL_READER_BUSY";
    PaymentFailureReason["TerminalReaderHardwareFault"] = "TERMINAL_READER_HARDWARE_FAULT";
    PaymentFailureReason["TerminalReaderInvalidLocationForPayment"] = "TERMINAL_READER_INVALID_LOCATION_FOR_PAYMENT";
    PaymentFailureReason["TerminalReaderOffline"] = "TERMINAL_READER_OFFLINE";
    PaymentFailureReason["TerminalReaderTimeout"] = "TERMINAL_READER_TIMEOUT";
    PaymentFailureReason["TestmodeChargesOnly"] = "TESTMODE_CHARGES_ONLY";
    PaymentFailureReason["TestmodeDecline"] = "TESTMODE_DECLINE";
    PaymentFailureReason["TlsVersionUnsupported"] = "TLS_VERSION_UNSUPPORTED";
    PaymentFailureReason["TokenAlreadyUsed"] = "TOKEN_ALREADY_USED";
    PaymentFailureReason["TokenCardNetworkInvalid"] = "TOKEN_CARD_NETWORK_INVALID";
    PaymentFailureReason["TokenInUse"] = "TOKEN_IN_USE";
    PaymentFailureReason["TransactionNotAllowed"] = "TRANSACTION_NOT_ALLOWED";
    PaymentFailureReason["TransfersNotAllowed"] = "TRANSFERS_NOT_ALLOWED";
    PaymentFailureReason["TransferSourceBalanceParametersMismatch"] = "TRANSFER_SOURCE_BALANCE_PARAMETERS_MISMATCH";
    PaymentFailureReason["TryAgainLater"] = "TRY_AGAIN_LATER";
    PaymentFailureReason["UrlInvalid"] = "URL_INVALID";
    PaymentFailureReason["WithdrawalCountLimitExceeded"] = "WITHDRAWAL_COUNT_LIMIT_EXCEEDED";
})(PaymentFailureReason || (PaymentFailureReason = {}));
var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["Ach"] = "ACH";
    PaymentMethodType["Card"] = "CARD";
    PaymentMethodType["GenesisTransaction"] = "GENESIS_TRANSACTION";
    PaymentMethodType["ManualWireTransaction"] = "MANUAL_WIRE_TRANSACTION";
})(PaymentMethodType || (PaymentMethodType = {}));
var PhoneType;
(function (PhoneType) {
    PhoneType["Fax"] = "FAX";
    PhoneType["Home"] = "HOME";
    PhoneType["Mobile"] = "MOBILE";
    PhoneType["Office"] = "OFFICE";
})(PhoneType || (PhoneType = {}));
var PostponementPrimaryReason;
(function (PostponementPrimaryReason) {
    PostponementPrimaryReason["Bankruptcy"] = "BANKRUPTCY";
    PostponementPrimaryReason["BeneficiaryRequest"] = "BENEFICIARY_REQUEST";
    PostponementPrimaryReason["CourtOrder"] = "COURT_ORDER";
    PostponementPrimaryReason["MutualAgreement"] = "MUTUAL_AGREEMENT";
    PostponementPrimaryReason["NaturalDisaster"] = "NATURAL_DISASTER";
    PostponementPrimaryReason["Other"] = "OTHER";
    PostponementPrimaryReason["TrusteeDiscretion"] = "TRUSTEE_DISCRETION";
})(PostponementPrimaryReason || (PostponementPrimaryReason = {}));
var PreAuctionOfferMinimumType;
(function (PreAuctionOfferMinimumType) {
    PreAuctionOfferMinimumType["AuctionSellerReserve"] = "AUCTION_SELLER_RESERVE";
    PreAuctionOfferMinimumType["FinalSellerReserve"] = "FINAL_SELLER_RESERVE";
    PreAuctionOfferMinimumType["ImpliedReserve"] = "IMPLIED_RESERVE";
    PreAuctionOfferMinimumType["NotSet"] = "NOT_SET";
    PreAuctionOfferMinimumType["SubjectToReserve"] = "SUBJECT_TO_RESERVE";
})(PreAuctionOfferMinimumType || (PreAuctionOfferMinimumType = {}));
var PreAuctionStatus;
(function (PreAuctionStatus) {
    PreAuctionStatus["Auction"] = "AUCTION";
    PreAuctionStatus["Cancelled"] = "CANCELLED";
    PreAuctionStatus["Deleted"] = "DELETED";
    PreAuctionStatus["Postponed"] = "POSTPONED";
    PreAuctionStatus["Removed"] = "REMOVED";
})(PreAuctionStatus || (PreAuctionStatus = {}));
var ProductType;
(function (ProductType) {
    ProductType["Day_1Reo"] = "DAY_1_REO";
    ProductType["FclMarketing"] = "FCL_MARKETING";
    ProductType["PrivateSeller"] = "PRIVATE_SELLER";
    ProductType["PrivateSellerIndividual"] = "PRIVATE_SELLER_INDIVIDUAL";
    ProductType["PrivateSellerInstitutional"] = "PRIVATE_SELLER_INSTITUTIONAL";
    ProductType["Redemption"] = "REDEMPTION";
    ProductType["Rentals"] = "RENTALS";
    ProductType["Reo"] = "REO";
    ProductType["ShortSale"] = "SHORT_SALE";
    ProductType["Trustee"] = "TRUSTEE";
})(ProductType || (ProductType = {}));
var PropertyCondition;
(function (PropertyCondition) {
    PropertyCondition["Dated"] = "DATED";
    PropertyCondition["FixerUpper"] = "FIXER_UPPER";
    PropertyCondition["Other"] = "OTHER";
    PropertyCondition["WellMaintained"] = "WELL_MAINTAINED";
})(PropertyCondition || (PropertyCondition = {}));
var PropertyDnaFieldIdentifiers;
(function (PropertyDnaFieldIdentifiers) {
    PropertyDnaFieldIdentifiers["Apn"] = "APN";
    PropertyDnaFieldIdentifiers["Bathrooms"] = "BATHROOMS";
    PropertyDnaFieldIdentifiers["Bedrooms"] = "BEDROOMS";
    PropertyDnaFieldIdentifiers["LotSize"] = "LOT_SIZE";
    PropertyDnaFieldIdentifiers["RentalEstimate"] = "RENTAL_ESTIMATE";
    PropertyDnaFieldIdentifiers["SquareFootage"] = "SQUARE_FOOTAGE";
    PropertyDnaFieldIdentifiers["StructureTypeCode"] = "STRUCTURE_TYPE_CODE";
    PropertyDnaFieldIdentifiers["Valuation"] = "VALUATION";
    PropertyDnaFieldIdentifiers["YearBuilt"] = "YEAR_BUILT";
})(PropertyDnaFieldIdentifiers || (PropertyDnaFieldIdentifiers = {}));
var PropertyDocumentPurposeType;
(function (PropertyDocumentPurposeType) {
    PropertyDocumentPurposeType["ActiveLease"] = "ACTIVE_LEASE";
    PropertyDocumentPurposeType["AdditionalDisclosure"] = "ADDITIONAL_DISCLOSURE";
    PropertyDocumentPurposeType["AgentVisualInspectionDisclosure"] = "AGENT_VISUAL_INSPECTION_DISCLOSURE";
    PropertyDocumentPurposeType["BrokerPriceOpinion"] = "BROKER_PRICE_OPINION";
    PropertyDocumentPurposeType["CodeViolations"] = "CODE_VIOLATIONS";
    PropertyDocumentPurposeType["CorporateResolution"] = "CORPORATE_RESOLUTION";
    PropertyDocumentPurposeType["CovenantsConditionsAndRestrictions"] = "COVENANTS_CONDITIONS_AND_RESTRICTIONS";
    PropertyDocumentPurposeType["HoldHarmlessAgreement"] = "HOLD_HARMLESS_AGREEMENT";
    PropertyDocumentPurposeType["IndemnificationAndHoldHarmless"] = "INDEMNIFICATION_AND_HOLD_HARMLESS";
    PropertyDocumentPurposeType["InspectionReport"] = "INSPECTION_REPORT";
    PropertyDocumentPurposeType["LeadBasedPaintDisclosure"] = "LEAD_BASED_PAINT_DISCLOSURE";
    PropertyDocumentPurposeType["LeaseAgreement"] = "LEASE_AGREEMENT";
    PropertyDocumentPurposeType["LegalDescription"] = "LEGAL_DESCRIPTION";
    PropertyDocumentPurposeType["LienDisclosure"] = "LIEN_DISCLOSURE";
    PropertyDocumentPurposeType["LocalDisclosure"] = "LOCAL_DISCLOSURE";
    PropertyDocumentPurposeType["MiscellaneousDocument"] = "MISCELLANEOUS_DOCUMENT";
    PropertyDocumentPurposeType["NaturalHazardDisclosure"] = "NATURAL_HAZARD_DISCLOSURE";
    PropertyDocumentPurposeType["NoticeOfSale"] = "NOTICE_OF_SALE";
    PropertyDocumentPurposeType["Others"] = "OTHERS";
    PropertyDocumentPurposeType["PlatMap"] = "PLAT_MAP";
    PropertyDocumentPurposeType["PreliminaryTitleReport"] = "PRELIMINARY_TITLE_REPORT";
    PropertyDocumentPurposeType["PropertyConditionAddendumAndRelease"] = "PROPERTY_CONDITION_ADDENDUM_AND_RELEASE";
    PropertyDocumentPurposeType["PropertyDataSheet"] = "PROPERTY_DATA_SHEET";
    PropertyDocumentPurposeType["PurchaseAgreement"] = "PURCHASE_AGREEMENT";
    PropertyDocumentPurposeType["RedactedBrokerPriceOpinion"] = "REDACTED_BROKER_PRICE_OPINION";
    PropertyDocumentPurposeType["RentLedger"] = "RENT_LEDGER";
    PropertyDocumentPurposeType["SellerSignDisclosures"] = "SELLER_SIGN_DISCLOSURES";
    PropertyDocumentPurposeType["SpecialAddendums"] = "SPECIAL_ADDENDUMS";
    PropertyDocumentPurposeType["SpecialDisclosures"] = "SPECIAL_DISCLOSURES";
    PropertyDocumentPurposeType["WireInstructions"] = "WIRE_INSTRUCTIONS";
})(PropertyDocumentPurposeType || (PropertyDocumentPurposeType = {}));
var PropertyDocumentUsageType;
(function (PropertyDocumentUsageType) {
    PropertyDocumentUsageType["Auctioneer"] = "AUCTIONEER";
    PropertyDocumentUsageType["Contracting"] = "CONTRACTING";
    PropertyDocumentUsageType["Inactive"] = "INACTIVE";
    PropertyDocumentUsageType["Internal"] = "INTERNAL";
    PropertyDocumentUsageType["Web"] = "WEB";
})(PropertyDocumentUsageType || (PropertyDocumentUsageType = {}));
var PropertyPhotoTag;
(function (PropertyPhotoTag) {
    PropertyPhotoTag["Backyard"] = "BACKYARD";
    PropertyPhotoTag["Bathroom"] = "BATHROOM";
    PropertyPhotoTag["Bedroom"] = "BEDROOM";
    PropertyPhotoTag["DiningRoom"] = "DINING_ROOM";
    PropertyPhotoTag["Exterior"] = "EXTERIOR";
    PropertyPhotoTag["ExteriorFront"] = "EXTERIOR_FRONT";
    PropertyPhotoTag["Garage"] = "GARAGE";
    PropertyPhotoTag["Kitchen"] = "KITCHEN";
    PropertyPhotoTag["LivingRoom"] = "LIVING_ROOM";
    PropertyPhotoTag["MasterBedroom"] = "MASTER_BEDROOM";
    PropertyPhotoTag["Pool"] = "POOL";
    PropertyPhotoTag["Stairs"] = "STAIRS";
})(PropertyPhotoTag || (PropertyPhotoTag = {}));
var PropertyStructureType;
(function (PropertyStructureType) {
    PropertyStructureType["ApartmentBuilding"] = "APARTMENT_BUILDING";
    PropertyStructureType["ApartmentComplex"] = "APARTMENT_COMPLEX";
    PropertyStructureType["ApartmentUnit"] = "APARTMENT_UNIT";
    PropertyStructureType["AttachedGarage"] = "ATTACHED_GARAGE";
    PropertyStructureType["CondominiumBuilding"] = "CONDOMINIUM_BUILDING";
    PropertyStructureType["CondominiumUnit"] = "CONDOMINIUM_UNIT";
    PropertyStructureType["CoopBuilding"] = "COOP_BUILDING";
    PropertyStructureType["CoopUnit"] = "COOP_UNIT";
    PropertyStructureType["DetachedGarage"] = "DETACHED_GARAGE";
    PropertyStructureType["DuplexBuilding"] = "DUPLEX_BUILDING";
    PropertyStructureType["DuplexUnit"] = "DUPLEX_UNIT";
    PropertyStructureType["Floor"] = "FLOOR";
    PropertyStructureType["FourPlexBuilding"] = "FOUR_PLEX_BUILDING";
    PropertyStructureType["FourPlexUnit"] = "FOUR_PLEX_UNIT";
    PropertyStructureType["HiRiseCondoUnit"] = "HI_RISE_CONDO_UNIT";
    PropertyStructureType["Land"] = "LAND";
    PropertyStructureType["Loft"] = "LOFT";
    PropertyStructureType["ManufacturedHome"] = "MANUFACTURED_HOME";
    PropertyStructureType["MobileHome"] = "MOBILE_HOME";
    PropertyStructureType["ModularHome"] = "MODULAR_HOME";
    PropertyStructureType["MultiUnitBuilding"] = "MULTI_UNIT_BUILDING";
    PropertyStructureType["Other"] = "OTHER";
    PropertyStructureType["PudHome"] = "PUD_HOME";
    PropertyStructureType["SingleFamilyAttached"] = "SINGLE_FAMILY_ATTACHED";
    PropertyStructureType["SingleFamilyDetached"] = "SINGLE_FAMILY_DETACHED";
    PropertyStructureType["SingleFamilyHome"] = "SINGLE_FAMILY_HOME";
    PropertyStructureType["Studio"] = "STUDIO";
    PropertyStructureType["ThreePlexBuilding"] = "THREE_PLEX_BUILDING";
    PropertyStructureType["ThreePlexUnit"] = "THREE_PLEX_UNIT";
    PropertyStructureType["Townhouse"] = "TOWNHOUSE";
})(PropertyStructureType || (PropertyStructureType = {}));
var PropertyStructureTypeGroup;
(function (PropertyStructureTypeGroup) {
    PropertyStructureTypeGroup["CondosAndTownhouses"] = "CONDOS_AND_TOWNHOUSES";
    PropertyStructureTypeGroup["Land"] = "LAND";
    PropertyStructureTypeGroup["MultiFamily"] = "MULTI_FAMILY";
    PropertyStructureTypeGroup["Other"] = "OTHER";
    PropertyStructureTypeGroup["SingleFamily"] = "SINGLE_FAMILY";
    PropertyStructureTypeGroup["SingleUnit"] = "SINGLE_UNIT";
    PropertyStructureTypeGroup["Unknown"] = "UNKNOWN";
})(PropertyStructureTypeGroup || (PropertyStructureTypeGroup = {}));
var PropertyValuationSource;
(function (PropertyValuationSource) {
    PropertyValuationSource["CollateralAnalytics"] = "COLLATERAL_ANALYTICS";
    PropertyValuationSource["Morpheus"] = "MORPHEUS";
    PropertyValuationSource["Servicer"] = "SERVICER";
})(PropertyValuationSource || (PropertyValuationSource = {}));
var PropertyValueDataSource;
(function (PropertyValueDataSource) {
    PropertyValueDataSource["CollateralAnalytics"] = "COLLATERAL_ANALYTICS";
    PropertyValueDataSource["Morpheus"] = "MORPHEUS";
    PropertyValueDataSource["Servicer"] = "SERVICER";
})(PropertyValueDataSource || (PropertyValueDataSource = {}));
var RecordStatus;
(function (RecordStatus) {
    RecordStatus["Active"] = "ACTIVE";
    RecordStatus["Inactive"] = "INACTIVE";
})(RecordStatus || (RecordStatus = {}));
var RefundIntentStatus;
(function (RefundIntentStatus) {
    RefundIntentStatus["Created"] = "CREATED";
    RefundIntentStatus["Pending"] = "PENDING";
})(RefundIntentStatus || (RefundIntentStatus = {}));
var RefundPayableTo;
(function (RefundPayableTo) {
    RefundPayableTo["Manual"] = "MANUAL";
    RefundPayableTo["Other"] = "OTHER";
    RefundPayableTo["Owner"] = "OWNER";
    RefundPayableTo["Representative"] = "REPRESENTATIVE";
    RefundPayableTo["Unknown"] = "UNKNOWN";
})(RefundPayableTo || (RefundPayableTo = {}));
var RelationshipToProperty;
(function (RelationshipToProperty) {
    RelationshipToProperty["Owner"] = "OWNER";
    RelationshipToProperty["OwnerWithAgent"] = "OWNER_WITH_AGENT";
    RelationshipToProperty["PartOwner"] = "PART_OWNER";
    RelationshipToProperty["RepresentativeOfOwner"] = "REPRESENTATIVE_OF_OWNER";
})(RelationshipToProperty || (RelationshipToProperty = {}));
var RemarkPurpose;
(function (RemarkPurpose) {
    RemarkPurpose["CommentFromTrusteeAttorney"] = "COMMENT_FROM_TRUSTEE_ATTORNEY";
})(RemarkPurpose || (RemarkPurpose = {}));
var ReoCancellationAdditionalDetails;
(function (ReoCancellationAdditionalDetails) {
    ReoCancellationAdditionalDetails["AssetConveyance"] = "ASSET_CONVEYANCE";
    ReoCancellationAdditionalDetails["AssetRemoved"] = "ASSET_REMOVED";
    ReoCancellationAdditionalDetails["AssetType"] = "ASSET_TYPE";
    ReoCancellationAdditionalDetails["BuyerAssigned"] = "BUYER_ASSIGNED";
    ReoCancellationAdditionalDetails["BuyerBreachOfContract"] = "BUYER_BREACH_OF_CONTRACT";
    ReoCancellationAdditionalDetails["BuyerNonResponsive"] = "BUYER_NON_RESPONSIVE";
    ReoCancellationAdditionalDetails["BuyerNotQualifiedForFirstLook"] = "BUYER_NOT_QUALIFIED_FOR_FIRST_LOOK";
    ReoCancellationAdditionalDetails["BuyerWalked"] = "BUYER_WALKED";
    ReoCancellationAdditionalDetails["ChangeInOccupancyStatus"] = "CHANGE_IN_OCCUPANCY_STATUS";
    ReoCancellationAdditionalDetails["ContractIssues"] = "CONTRACT_ISSUES";
    ReoCancellationAdditionalDetails["CoOpDenialDelay"] = "CO_OP_DENIAL_DELAY";
    ReoCancellationAdditionalDetails["DelayInShortSaleOfferApproval"] = "DELAY_IN_SHORT_SALE_OFFER_APPROVAL";
    ReoCancellationAdditionalDetails["EmdNotDeposited"] = "EMD_NOT_DEPOSITED";
    ReoCancellationAdditionalDetails["Emergency"] = "EMERGENCY";
    ReoCancellationAdditionalDetails["FinalAcquisitionOfThePropertyByTheSeller"] = "FINAL_ACQUISITION_OF_THE_PROPERTY_BY_THE_SELLER";
    ReoCancellationAdditionalDetails["FinancingFailed"] = "FINANCING_FAILED";
    ReoCancellationAdditionalDetails["ForeclosureDeedNotRecorded"] = "FORECLOSURE_DEED_NOT_RECORDED";
    ReoCancellationAdditionalDetails["ForeclosureOnHold"] = "FORECLOSURE_ON_HOLD";
    ReoCancellationAdditionalDetails["FundsToClose"] = "FUNDS_TO_CLOSE";
    ReoCancellationAdditionalDetails["HazardousConditions"] = "HAZARDOUS_CONDITIONS";
    ReoCancellationAdditionalDetails["HoaRestrictionOrIssues"] = "HOA_RESTRICTION_OR_ISSUES";
    ReoCancellationAdditionalDetails["IfRequiredBySellerTheRepurchaseOfThePropertyByThePriorMortgageServicerFromSeller"] = "IF_REQUIRED_BY_SELLER_THE_REPURCHASE_OF_THE_PROPERTY_BY_THE_PRIOR_MORTGAGE_SERVICER_FROM_SELLER";
    ReoCancellationAdditionalDetails["InspectionIssues"] = "INSPECTION_ISSUES";
    ReoCancellationAdditionalDetails["OccupantDeniedInspection"] = "OCCUPANT_DENIED_INSPECTION";
    ReoCancellationAdditionalDetails["OfferRejectedByBorrowerSeller"] = "OFFER_REJECTED_BY_BORROWER_SELLER";
    ReoCancellationAdditionalDetails["OfferRejectedByServicer"] = "OFFER_REJECTED_BY_SERVICER";
    ReoCancellationAdditionalDetails["Other"] = "OTHER";
    ReoCancellationAdditionalDetails["PendingLitigation"] = "PENDING_LITIGATION";
    ReoCancellationAdditionalDetails["PosInspectionIssues"] = "POS_INSPECTION_ISSUES";
    ReoCancellationAdditionalDetails["PropertyConditionInspection"] = "PROPERTY_CONDITION_INSPECTION";
    ReoCancellationAdditionalDetails["PropertyIssues"] = "PROPERTY_ISSUES";
    ReoCancellationAdditionalDetails["RedemptionPeriod"] = "REDEMPTION_PERIOD";
    ReoCancellationAdditionalDetails["Reforeclosure"] = "REFORECLOSURE";
    ReoCancellationAdditionalDetails["ReEnterSaleTerms"] = "RE_ENTER_SALE_TERMS";
    ReoCancellationAdditionalDetails["RightOfFirstRefusalByCoaHoaCoOp"] = "RIGHT_OF_FIRST_REFUSAL_BY_COA_HOA_CO_OP";
    ReoCancellationAdditionalDetails["RightOfRedemption"] = "RIGHT_OF_REDEMPTION";
    ReoCancellationAdditionalDetails["SellerAssigned"] = "SELLER_ASSIGNED";
    ReoCancellationAdditionalDetails["SellerRejectedRequestToCompleteRepairs"] = "SELLER_REJECTED_REQUEST_TO_COMPLETE_REPAIRS";
    ReoCancellationAdditionalDetails["SellerRejectedRequestToExtendClosing"] = "SELLER_REJECTED_REQUEST_TO_EXTEND_CLOSING";
    ReoCancellationAdditionalDetails["TermsOfLease"] = "TERMS_OF_LEASE";
    ReoCancellationAdditionalDetails["TheAbilityOfSellerToProvideInsurableTitle"] = "THE_ABILITY_OF_SELLER_TO_PROVIDE_INSURABLE_TITLE";
    ReoCancellationAdditionalDetails["TheMortgageInsuranceCompanysApprovalOfTheSale"] = "THE_MORTGAGE_INSURANCE_COMPANYS_APPROVAL_OF_THE_SALE";
    ReoCancellationAdditionalDetails["TitleIssues"] = "TITLE_ISSUES";
    ReoCancellationAdditionalDetails["UncooperativeOccupant"] = "UNCOOPERATIVE_OCCUPANT";
    ReoCancellationAdditionalDetails["WeatherDisaster"] = "WEATHER_DISASTER";
    ReoCancellationAdditionalDetails["WeatherDisasterAffectedProperty"] = "WEATHER_DISASTER_AFFECTED_PROPERTY";
    ReoCancellationAdditionalDetails["WinningBidDispute"] = "WINNING_BID_DISPUTE";
})(ReoCancellationAdditionalDetails || (ReoCancellationAdditionalDetails = {}));
var ReoCancellationReason;
(function (ReoCancellationReason) {
    ReoCancellationReason["BuyerNonPerformance"] = "BUYER_NON_PERFORMANCE";
    ReoCancellationReason["BuyerTermination"] = "BUYER_TERMINATION";
    ReoCancellationReason["SellerTermination"] = "SELLER_TERMINATION";
    ReoCancellationReason["ShortSaleIssue"] = "SHORT_SALE_ISSUE";
    ReoCancellationReason["TitleCompanyPerformance"] = "TITLE_COMPANY_PERFORMANCE";
})(ReoCancellationReason || (ReoCancellationReason = {}));
var ReoContractDocumentGenerationProcessCode;
(function (ReoContractDocumentGenerationProcessCode) {
    ReoContractDocumentGenerationProcessCode["McdsAndInternalEnabled"] = "MCDS_AND_INTERNAL_ENABLED";
    ReoContractDocumentGenerationProcessCode["NoContractingEnabled"] = "NO_CONTRACTING_ENABLED";
    ReoContractDocumentGenerationProcessCode["OnlyInternalEnabled"] = "ONLY_INTERNAL_ENABLED";
    ReoContractDocumentGenerationProcessCode["OnlyMcdsEnabled"] = "ONLY_MCDS_ENABLED";
})(ReoContractDocumentGenerationProcessCode || (ReoContractDocumentGenerationProcessCode = {}));
var ReoContractMediaFileType;
(function (ReoContractMediaFileType) {
    ReoContractMediaFileType["Addendum"] = "ADDENDUM";
    ReoContractMediaFileType["AmendedAddendum"] = "AMENDED_ADDENDUM";
    ReoContractMediaFileType["AmendedContractSigned"] = "AMENDED_CONTRACT_SIGNED";
    ReoContractMediaFileType["AmendedContractUnsigned"] = "AMENDED_CONTRACT_UNSIGNED";
    ReoContractMediaFileType["CancellationSigned"] = "CANCELLATION_SIGNED";
    ReoContractMediaFileType["CancellationUnsigned"] = "CANCELLATION_UNSIGNED";
    ReoContractMediaFileType["ClosingReport"] = "CLOSING_REPORT";
    ReoContractMediaFileType["EstimatedHud"] = "ESTIMATED_HUD";
    ReoContractMediaFileType["ExtensionSigned"] = "EXTENSION_SIGNED";
    ReoContractMediaFileType["ExtensionUnsigned"] = "EXTENSION_UNSIGNED";
    ReoContractMediaFileType["FinalHud"] = "FINAL_HUD";
    ReoContractMediaFileType["InternalPreview"] = "INTERNAL_PREVIEW";
    ReoContractMediaFileType["InternalSellerSignedContract"] = "INTERNAL_SELLER_SIGNED_CONTRACT";
    ReoContractMediaFileType["InternalSignedContract"] = "INTERNAL_SIGNED_CONTRACT";
    ReoContractMediaFileType["InternalUnsignedContract"] = "INTERNAL_UNSIGNED_CONTRACT";
    ReoContractMediaFileType["Invalid"] = "INVALID";
    ReoContractMediaFileType["MiscClosingDoc"] = "MISC_CLOSING_DOC";
    ReoContractMediaFileType["Preview"] = "PREVIEW";
    ReoContractMediaFileType["ProofOfFunds"] = "PROOF_OF_FUNDS";
    ReoContractMediaFileType["Sample"] = "SAMPLE";
    ReoContractMediaFileType["SellerSignedContract"] = "SELLER_SIGNED_CONTRACT";
    ReoContractMediaFileType["SignedContract"] = "SIGNED_CONTRACT";
    ReoContractMediaFileType["TransactionDetailsSheet"] = "TRANSACTION_DETAILS_SHEET";
    ReoContractMediaFileType["UnsignedContract"] = "UNSIGNED_CONTRACT";
})(ReoContractMediaFileType || (ReoContractMediaFileType = {}));
var ReoOfferBuyerOccupancyCode;
(function (ReoOfferBuyerOccupancyCode) {
    ReoOfferBuyerOccupancyCode["Investment"] = "INVESTMENT";
    ReoOfferBuyerOccupancyCode["OwnerOccupied"] = "OWNER_OCCUPIED";
    ReoOfferBuyerOccupancyCode["SecondHome"] = "SECOND_HOME";
})(ReoOfferBuyerOccupancyCode || (ReoOfferBuyerOccupancyCode = {}));
var ReoOfferCancellationServicerDecision;
(function (ReoOfferCancellationServicerDecision) {
    ReoOfferCancellationServicerDecision["Approved"] = "APPROVED";
    ReoOfferCancellationServicerDecision["Modified"] = "MODIFIED";
    ReoOfferCancellationServicerDecision["Pending"] = "PENDING";
    ReoOfferCancellationServicerDecision["Rejected"] = "REJECTED";
})(ReoOfferCancellationServicerDecision || (ReoOfferCancellationServicerDecision = {}));
var ReoOfferCertifiedBuyerType;
(function (ReoOfferCertifiedBuyerType) {
    ReoOfferCertifiedBuyerType["BuyerNotQualified"] = "BUYER_NOT_QUALIFIED";
    ReoOfferCertifiedBuyerType["GovernmentEntity"] = "GOVERNMENT_ENTITY";
    ReoOfferCertifiedBuyerType["HudApprovedNonProfit"] = "HUD_APPROVED_NON_PROFIT";
    ReoOfferCertifiedBuyerType["Investor"] = "INVESTOR";
    ReoOfferCertifiedBuyerType["NonProfit"] = "NON_PROFIT";
    ReoOfferCertifiedBuyerType["OwnerOccupant"] = "OWNER_OCCUPANT";
    ReoOfferCertifiedBuyerType["StateAgency"] = "STATE_AGENCY";
    ReoOfferCertifiedBuyerType["StateCommunityLandTrust"] = "STATE_COMMUNITY_LAND_TRUST";
    ReoOfferCertifiedBuyerType["StateLtdEquityHousingCorp"] = "STATE_LTD_EQUITY_HOUSING_CORP";
    ReoOfferCertifiedBuyerType["StateRequiredNonProfit"] = "STATE_REQUIRED_NON_PROFIT";
})(ReoOfferCertifiedBuyerType || (ReoOfferCertifiedBuyerType = {}));
var ReoOfferDocumentRecipientType;
(function (ReoOfferDocumentRecipientType) {
    ReoOfferDocumentRecipientType["Agent"] = "AGENT";
    ReoOfferDocumentRecipientType["CarbonCopy"] = "CARBON_COPY";
    ReoOfferDocumentRecipientType["CertifiedDelivery"] = "CERTIFIED_DELIVERY";
    ReoOfferDocumentRecipientType["Editor"] = "EDITOR";
    ReoOfferDocumentRecipientType["Intermediary"] = "INTERMEDIARY";
    ReoOfferDocumentRecipientType["Invalid"] = "INVALID";
    ReoOfferDocumentRecipientType["InPersonSigner"] = "IN_PERSON_SIGNER";
    ReoOfferDocumentRecipientType["Signer"] = "SIGNER";
    ReoOfferDocumentRecipientType["SigningHost"] = "SIGNING_HOST";
})(ReoOfferDocumentRecipientType || (ReoOfferDocumentRecipientType = {}));
var ReoOfferExtensionAdditionalDetails;
(function (ReoOfferExtensionAdditionalDetails) {
    ReoOfferExtensionAdditionalDetails["ApprovalToPayFees"] = "APPROVAL_TO_PAY_FEES";
    ReoOfferExtensionAdditionalDetails["ApprovalToPayRepairs"] = "APPROVAL_TO_PAY_REPAIRS";
    ReoOfferExtensionAdditionalDetails["DemandIssue"] = "DEMAND_ISSUE";
    ReoOfferExtensionAdditionalDetails["Escalation"] = "ESCALATION";
    ReoOfferExtensionAdditionalDetails["ForeclosureDeedNotRecorded"] = "FORECLOSURE_DEED_NOT_RECORDED";
    ReoOfferExtensionAdditionalDetails["HoaIssuesDelay"] = "HOA_ISSUES_DELAY";
    ReoOfferExtensionAdditionalDetails["Inspections"] = "INSPECTIONS";
    ReoOfferExtensionAdditionalDetails["LenderFinancingDelay"] = "LENDER_FINANCING_DELAY";
    ReoOfferExtensionAdditionalDetails["LienIssue"] = "LIEN_ISSUE";
    ReoOfferExtensionAdditionalDetails["Other"] = "OTHER";
    ReoOfferExtensionAdditionalDetails["RepairCompletion"] = "REPAIR_COMPLETION";
    ReoOfferExtensionAdditionalDetails["TimelineAtContractExecution"] = "TIMELINE_AT_CONTRACT_EXECUTION";
    ReoOfferExtensionAdditionalDetails["TitleCurative"] = "TITLE_CURATIVE";
})(ReoOfferExtensionAdditionalDetails || (ReoOfferExtensionAdditionalDetails = {}));
var ReoOfferExtensionReason;
(function (ReoOfferExtensionReason) {
    ReoOfferExtensionReason["BuyerDelay"] = "BUYER_DELAY";
    ReoOfferExtensionReason["CloserEscrowDelay"] = "CLOSER_ESCROW_DELAY";
    ReoOfferExtensionReason["LenderDelay"] = "LENDER_DELAY";
    ReoOfferExtensionReason["LiensDemandsDelay"] = "LIENS_DEMANDS_DELAY";
    ReoOfferExtensionReason["PropertyIssues"] = "PROPERTY_ISSUES";
    ReoOfferExtensionReason["SellerDelay"] = "SELLER_DELAY";
})(ReoOfferExtensionReason || (ReoOfferExtensionReason = {}));
var ReoOfferExtensionServicerDecision;
(function (ReoOfferExtensionServicerDecision) {
    ReoOfferExtensionServicerDecision["Approved"] = "APPROVED";
    ReoOfferExtensionServicerDecision["Modified"] = "MODIFIED";
    ReoOfferExtensionServicerDecision["Pending"] = "PENDING";
    ReoOfferExtensionServicerDecision["Rejected"] = "REJECTED";
})(ReoOfferExtensionServicerDecision || (ReoOfferExtensionServicerDecision = {}));
var ReoOfferLendingStatus;
(function (ReoOfferLendingStatus) {
    ReoOfferLendingStatus["Approved"] = "APPROVED";
    ReoOfferLendingStatus["ApprovedWithConditions"] = "APPROVED_WITH_CONDITIONS";
    ReoOfferLendingStatus["CashIe"] = "CASH_IE";
    ReoOfferLendingStatus["CashNotIe"] = "CASH_NOT_IE";
    ReoOfferLendingStatus["Denied"] = "DENIED";
    ReoOfferLendingStatus["DocsBack"] = "DOCS_BACK";
    ReoOfferLendingStatus["DocsOrdered"] = "DOCS_ORDERED";
    ReoOfferLendingStatus["DocsOut"] = "DOCS_OUT";
    ReoOfferLendingStatus["Funded"] = "FUNDED";
    ReoOfferLendingStatus["PendingAppraisalDocs"] = "PENDING_APPRAISAL_DOCS";
    ReoOfferLendingStatus["Prequalified"] = "PREQUALIFIED";
    ReoOfferLendingStatus["SubmittedToUw"] = "SUBMITTED_TO_UW";
})(ReoOfferLendingStatus || (ReoOfferLendingStatus = {}));
var ReoOfferOwningEntitySubType;
(function (ReoOfferOwningEntitySubType) {
    ReoOfferOwningEntitySubType["Cobuyer"] = "COBUYER";
    ReoOfferOwningEntitySubType["Corporation"] = "CORPORATION";
    ReoOfferOwningEntitySubType["GeneralPartnership"] = "GENERAL_PARTNERSHIP";
    ReoOfferOwningEntitySubType["Individual"] = "INDIVIDUAL";
    ReoOfferOwningEntitySubType["Ira"] = "IRA";
    ReoOfferOwningEntitySubType["LimitedPartnership"] = "LIMITED_PARTNERSHIP";
    ReoOfferOwningEntitySubType["Llc"] = "LLC";
    ReoOfferOwningEntitySubType["LtdLiabilityPartnership"] = "LTD_LIABILITY_PARTNERSHIP";
    ReoOfferOwningEntitySubType["PensionPlan"] = "PENSION_PLAN";
    ReoOfferOwningEntitySubType["Retirement_401K"] = "RETIREMENT_401K";
    ReoOfferOwningEntitySubType["SeriesLlc"] = "SERIES_LLC";
    ReoOfferOwningEntitySubType["Trust"] = "TRUST";
})(ReoOfferOwningEntitySubType || (ReoOfferOwningEntitySubType = {}));
var ReoOfferOwningEntityType;
(function (ReoOfferOwningEntityType) {
    ReoOfferOwningEntityType["Cobuyer"] = "COBUYER";
    ReoOfferOwningEntityType["Entity"] = "ENTITY";
    ReoOfferOwningEntityType["Individual"] = "INDIVIDUAL";
    ReoOfferOwningEntityType["RetirementPlan"] = "RETIREMENT_PLAN";
    ReoOfferOwningEntityType["Trust"] = "TRUST";
})(ReoOfferOwningEntityType || (ReoOfferOwningEntityType = {}));
var ReoOfferPurchaseType;
(function (ReoOfferPurchaseType) {
    ReoOfferPurchaseType["Investment"] = "INVESTMENT";
    ReoOfferPurchaseType["Primary"] = "PRIMARY";
    ReoOfferPurchaseType["Secondary"] = "SECONDARY";
})(ReoOfferPurchaseType || (ReoOfferPurchaseType = {}));
var ReoOfferRealEstateAgentType;
(function (ReoOfferRealEstateAgentType) {
    ReoOfferRealEstateAgentType["Agent"] = "AGENT";
    ReoOfferRealEstateAgentType["None"] = "NONE";
    ReoOfferRealEstateAgentType["Self"] = "SELF";
})(ReoOfferRealEstateAgentType || (ReoOfferRealEstateAgentType = {}));
var ReoOfferStatus;
(function (ReoOfferStatus) {
    ReoOfferStatus["Complete"] = "COMPLETE";
    ReoOfferStatus["ContractReceived"] = "CONTRACT_RECEIVED";
    ReoOfferStatus["ContractSent"] = "CONTRACT_SENT";
    ReoOfferStatus["InProgress"] = "IN_PROGRESS";
    ReoOfferStatus["New"] = "NEW";
    ReoOfferStatus["Review"] = "REVIEW";
})(ReoOfferStatus || (ReoOfferStatus = {}));
var ReoOfferVestingType;
(function (ReoOfferVestingType) {
    ReoOfferVestingType["CommunityProperty"] = "COMMUNITY_PROPERTY";
    ReoOfferVestingType["CommunityPropertyRos"] = "COMMUNITY_PROPERTY_ROS";
    ReoOfferVestingType["Entity"] = "ENTITY";
    ReoOfferVestingType["Individual"] = "INDIVIDUAL";
    ReoOfferVestingType["JointTenants"] = "JOINT_TENANTS";
    ReoOfferVestingType["Other"] = "OTHER";
    ReoOfferVestingType["SoleAndSeparate"] = "SOLE_AND_SEPARATE";
    ReoOfferVestingType["SoleOwnership"] = "SOLE_OWNERSHIP";
    ReoOfferVestingType["TenantsByEntireties"] = "TENANTS_BY_ENTIRETIES";
    ReoOfferVestingType["TenantsInCommon"] = "TENANTS_IN_COMMON";
})(ReoOfferVestingType || (ReoOfferVestingType = {}));
var RescissionReason;
(function (RescissionReason) {
    RescissionReason["AttorneyError"] = "ATTORNEY_ERROR";
    RescissionReason["Bankruptcy"] = "BANKRUPTCY";
    RescissionReason["BuyerNonPerformance"] = "BUYER_NON_PERFORMANCE";
    RescissionReason["CourtVacatedOrder"] = "COURT_VACATED_ORDER";
    RescissionReason["LossMitigation"] = "LOSS_MITIGATION";
    RescissionReason["Other"] = "OTHER";
    RescissionReason["Reinstatement"] = "REINSTATEMENT";
    RescissionReason["ServicerRequest"] = "SERVICER_REQUEST";
})(RescissionReason || (RescissionReason = {}));
var ReserveStatus;
(function (ReserveStatus) {
    ReserveStatus["ReserveMet"] = "RESERVE_MET";
    ReserveStatus["ReserveNotMet"] = "RESERVE_NOT_MET";
    ReserveStatus["SubjectToReserveMet"] = "SUBJECT_TO_RESERVE_MET";
})(ReserveStatus || (ReserveStatus = {}));
var ResolvePolicy;
(function (ResolvePolicy) {
    ResolvePolicy["CacheAndOrigin"] = "CACHE_AND_ORIGIN";
    ResolvePolicy["CacheOnly"] = "CACHE_ONLY";
    ResolvePolicy["OriginOnly"] = "ORIGIN_ONLY";
})(ResolvePolicy || (ResolvePolicy = {}));
var ReviewableResourceStatus;
(function (ReviewableResourceStatus) {
    ReviewableResourceStatus["HasPendingReviews"] = "HAS_PENDING_REVIEWS";
    ReviewableResourceStatus["NoPendingReviews"] = "NO_PENDING_REVIEWS";
})(ReviewableResourceStatus || (ReviewableResourceStatus = {}));
var SalesforceSubscriptionGroup;
(function (SalesforceSubscriptionGroup) {
    SalesforceSubscriptionGroup["Events"] = "EVENTS";
    SalesforceSubscriptionGroup["LiveAuctionUpdates"] = "LIVE_AUCTION_UPDATES";
    SalesforceSubscriptionGroup["Newsletters"] = "NEWSLETTERS";
    SalesforceSubscriptionGroup["PropertyRecommendations"] = "PROPERTY_RECOMMENDATIONS";
})(SalesforceSubscriptionGroup || (SalesforceSubscriptionGroup = {}));
var SavedSearchSource;
(function (SavedSearchSource) {
    SavedSearchSource["Adc"] = "ADC";
    SavedSearchSource["All"] = "ALL";
    SavedSearchSource["Morpheus"] = "MORPHEUS";
})(SavedSearchSource || (SavedSearchSource = {}));
var ScheduleFailureReason;
(function (ScheduleFailureReason) {
    ScheduleFailureReason["InternalError"] = "INTERNAL_ERROR";
    ScheduleFailureReason["ManyMatch"] = "MANY_MATCH";
    ScheduleFailureReason["MissingCriteria"] = "MISSING_CRITERIA";
    ScheduleFailureReason["NoMatch"] = "NO_MATCH";
    ScheduleFailureReason["RequiresNewSchedule"] = "REQUIRES_NEW_SCHEDULE";
    ScheduleFailureReason["RequiresNewVenue"] = "REQUIRES_NEW_VENUE";
})(ScheduleFailureReason || (ScheduleFailureReason = {}));
var ScheduleStatus;
(function (ScheduleStatus) {
    ScheduleStatus["Failed"] = "FAILED";
    ScheduleStatus["PendingScheduling"] = "PENDING_SCHEDULING";
    ScheduleStatus["Scheduled"] = "SCHEDULED";
})(ScheduleStatus || (ScheduleStatus = {}));
var SealedBidFieldFeedbackStatus;
(function (SealedBidFieldFeedbackStatus) {
    SealedBidFieldFeedbackStatus["Acknowledge"] = "ACKNOWLEDGE";
    SealedBidFieldFeedbackStatus["Unseen"] = "UNSEEN";
})(SealedBidFieldFeedbackStatus || (SealedBidFieldFeedbackStatus = {}));
var SealedBidProposedTermFieldType;
(function (SealedBidProposedTermFieldType) {
    SealedBidProposedTermFieldType["AgentCommissionAmount"] = "AGENT_COMMISSION_AMOUNT";
    SealedBidProposedTermFieldType["AgentCommissionPaidBy"] = "AGENT_COMMISSION_PAID_BY";
    SealedBidProposedTermFieldType["AppraisalContingencyDuration"] = "APPRAISAL_CONTINGENCY_DURATION";
    SealedBidProposedTermFieldType["CloseEscrowDuration"] = "CLOSE_ESCROW_DURATION";
    SealedBidProposedTermFieldType["DownPaymentAmount"] = "DOWN_PAYMENT_AMOUNT";
    SealedBidProposedTermFieldType["EarnestMoneyDepositAmount"] = "EARNEST_MONEY_DEPOSIT_AMOUNT";
    SealedBidProposedTermFieldType["FinancingContingencyDuration"] = "FINANCING_CONTINGENCY_DURATION";
    SealedBidProposedTermFieldType["InspectionContingencyPeriodCostAmount"] = "INSPECTION_CONTINGENCY_PERIOD_COST_AMOUNT";
    SealedBidProposedTermFieldType["InspectionContingencyPeriodDuration"] = "INSPECTION_CONTINGENCY_PERIOD_DURATION";
    SealedBidProposedTermFieldType["LeasebackAmount"] = "LEASEBACK_AMOUNT";
    SealedBidProposedTermFieldType["LeasebackDuration"] = "LEASEBACK_DURATION";
    SealedBidProposedTermFieldType["OfferAmount"] = "OFFER_AMOUNT";
    SealedBidProposedTermFieldType["PaymentType"] = "PAYMENT_TYPE";
    SealedBidProposedTermFieldType["SellerConcessionAmount"] = "SELLER_CONCESSION_AMOUNT";
})(SealedBidProposedTermFieldType || (SealedBidProposedTermFieldType = {}));
var SealedBidStatus;
(function (SealedBidStatus) {
    SealedBidStatus["BuyerAccepted"] = "BUYER_ACCEPTED";
    SealedBidStatus["BuyerCountered"] = "BUYER_COUNTERED";
    SealedBidStatus["BuyerRejected"] = "BUYER_REJECTED";
    SealedBidStatus["Expired"] = "EXPIRED";
    SealedBidStatus["ReSubmitted"] = "RE_SUBMITTED";
    SealedBidStatus["SellerAccepted"] = "SELLER_ACCEPTED";
    SealedBidStatus["SellerCountered"] = "SELLER_COUNTERED";
    SealedBidStatus["SellerCounterExpired"] = "SELLER_COUNTER_EXPIRED";
    SealedBidStatus["SellerCounterRejected"] = "SELLER_COUNTER_REJECTED";
    SealedBidStatus["SellerRejected"] = "SELLER_REJECTED";
    SealedBidStatus["Unset"] = "UNSET";
    SealedBidStatus["Withdrawn"] = "WITHDRAWN";
})(SealedBidStatus || (SealedBidStatus = {}));
var SeekQueryType;
(function (SeekQueryType) {
    SeekQueryType["ActiveListings"] = "ACTIVE_LISTINGS";
    SeekQueryType["AttorneyDashboardProjections"] = "ATTORNEY_DASHBOARD_PROJECTIONS";
    SeekQueryType["AuctioneerDashboardProjections"] = "AUCTIONEER_DASHBOARD_PROJECTIONS";
    SeekQueryType["Events"] = "EVENTS";
    SeekQueryType["EventTemplates"] = "EVENT_TEMPLATES";
    SeekQueryType["GlobalMedia"] = "GLOBAL_MEDIA";
    SeekQueryType["Invitations"] = "INVITATIONS";
    SeekQueryType["Listings"] = "LISTINGS";
    SeekQueryType["MarketingPackages"] = "MARKETING_PACKAGES";
    SeekQueryType["MediaPackages"] = "MEDIA_PACKAGES";
    SeekQueryType["MlhSyncLogs"] = "MLH_SYNC_LOGS";
    SeekQueryType["MorphLogs"] = "MORPH_LOGS";
    SeekQueryType["Properties"] = "PROPERTIES";
    SeekQueryType["Venues"] = "VENUES";
    SeekQueryType["VenueTemplates"] = "VENUE_TEMPLATES";
})(SeekQueryType || (SeekQueryType = {}));
var SellerAction;
(function (SellerAction) {
    SellerAction["BidAccepted"] = "BID_ACCEPTED";
    SellerAction["BidAcceptedSubjectTo"] = "BID_ACCEPTED_SUBJECT_TO";
    SellerAction["None"] = "NONE";
    SellerAction["PassedOnBid"] = "PASSED_ON_BID";
    SellerAction["ReserveChange"] = "RESERVE_CHANGE";
    SellerAction["UpdatedSubjectToReserveChange"] = "UPDATED_SUBJECT_TO_RESERVE_CHANGE";
})(SellerAction || (SellerAction = {}));
var SellerAssignedSigner;
(function (SellerAssignedSigner) {
    SellerAssignedSigner["AdcPoa"] = "ADC_POA";
    SellerAssignedSigner["BackupSigner"] = "BACKUP_SIGNER";
    SellerAssignedSigner["ClosingCompany"] = "CLOSING_COMPANY";
    SellerAssignedSigner["NoSignerName"] = "NO_SIGNER_NAME";
    SellerAssignedSigner["ServicerAssetManager"] = "SERVICER_ASSET_MANAGER";
    SellerAssignedSigner["SignerName"] = "SIGNER_NAME";
})(SellerAssignedSigner || (SellerAssignedSigner = {}));
var SellerConfigurationDeedType;
(function (SellerConfigurationDeedType) {
    SellerConfigurationDeedType["QdAssignmentCert"] = "QD_ASSIGNMENT_CERT";
    SellerConfigurationDeedType["QdAssignmentInterest"] = "QD_ASSIGNMENT_INTEREST";
    SellerConfigurationDeedType["QuitclaimDeed"] = "QUITCLAIM_DEED";
    SellerConfigurationDeedType["ReleaseDeed"] = "RELEASE_DEED";
    SellerConfigurationDeedType["SpecialWarrantyDeed"] = "SPECIAL_WARRANTY_DEED";
    SellerConfigurationDeedType["TrusteeDeed"] = "TRUSTEE_DEED";
    SellerConfigurationDeedType["WarrantyDeed"] = "WARRANTY_DEED";
})(SellerConfigurationDeedType || (SellerConfigurationDeedType = {}));
var SellerConfigurationLineOfBusiness;
(function (SellerConfigurationLineOfBusiness) {
    SellerConfigurationLineOfBusiness["Fcl"] = "FCL";
    SellerConfigurationLineOfBusiness["Pfs"] = "PFS";
    SellerConfigurationLineOfBusiness["Reo"] = "REO";
})(SellerConfigurationLineOfBusiness || (SellerConfigurationLineOfBusiness = {}));
var SellerConfigurationPartyRole;
(function (SellerConfigurationPartyRole) {
    SellerConfigurationPartyRole["ForeclosureAttorney"] = "FORECLOSURE_ATTORNEY";
    SellerConfigurationPartyRole["Investor"] = "INVESTOR";
    SellerConfigurationPartyRole["ParentCompany"] = "PARENT_COMPANY";
    SellerConfigurationPartyRole["ParentSeller"] = "PARENT_SELLER";
    SellerConfigurationPartyRole["Seller"] = "SELLER";
    SellerConfigurationPartyRole["Servicer"] = "SERVICER";
})(SellerConfigurationPartyRole || (SellerConfigurationPartyRole = {}));
var SellerConfigurationPortfolio;
(function (SellerConfigurationPortfolio) {
    SellerConfigurationPortfolio["Hud"] = "HUD";
    SellerConfigurationPortfolio["HudMarketingFcl"] = "HUD_MARKETING_FCL";
    SellerConfigurationPortfolio["NonClient"] = "NON_CLIENT";
    SellerConfigurationPortfolio["Npl"] = "NPL";
    SellerConfigurationPortfolio["Private"] = "PRIVATE";
    SellerConfigurationPortfolio["Usda"] = "USDA";
    SellerConfigurationPortfolio["Va"] = "VA";
})(SellerConfigurationPortfolio || (SellerConfigurationPortfolio = {}));
var SellerConfigurationProduct;
(function (SellerConfigurationProduct) {
    SellerConfigurationProduct["Cwcot"] = "CWCOT";
    SellerConfigurationProduct["Fcl"] = "FCL";
    SellerConfigurationProduct["NonReo"] = "NON_REO";
    SellerConfigurationProduct["Reo"] = "REO";
    SellerConfigurationProduct["Ss"] = "SS";
})(SellerConfigurationProduct || (SellerConfigurationProduct = {}));
var SellerConfigurationProgram;
(function (SellerConfigurationProgram) {
    SellerConfigurationProgram["Alvs"] = "ALVS";
    SellerConfigurationProgram["Auctioneer"] = "AUCTIONEER";
    SellerConfigurationProgram["Bankruptcy"] = "BANKRUPTCY";
    SellerConfigurationProgram["C2C"] = "C2C";
    SellerConfigurationProgram["C6"] = "C6";
    SellerConfigurationProgram["Concierge"] = "CONCIERGE";
    SellerConfigurationProgram["Cwcot"] = "CWCOT";
    SellerConfigurationProgram["CwcotRedemption"] = "CWCOT_REDEMPTION";
    SellerConfigurationProgram["Day_1Reo"] = "DAY_1_REO";
    SellerConfigurationProgram["DualPath"] = "DUAL_PATH";
    SellerConfigurationProgram["Hoc"] = "HOC";
    SellerConfigurationProgram["Luxury"] = "LUXURY";
    SellerConfigurationProgram["Mixed"] = "MIXED";
    SellerConfigurationProgram["Mvp"] = "MVP";
    SellerConfigurationProgram["NonReo"] = "NON_REO";
    SellerConfigurationProgram["NvaOoba"] = "NVA_OOBA";
    SellerConfigurationProgram["Opm"] = "OPM";
    SellerConfigurationProgram["Pmk"] = "PMK";
    SellerConfigurationProgram["PmkByob"] = "PMK_BYOB";
    SellerConfigurationProgram["Redemption"] = "REDEMPTION";
    SellerConfigurationProgram["Rental"] = "RENTAL";
    SellerConfigurationProgram["Retail"] = "RETAIL";
    SellerConfigurationProgram["Traditional"] = "TRADITIONAL";
    SellerConfigurationProgram["TraditionalByob"] = "TRADITIONAL_BYOB";
    SellerConfigurationProgram["TraditionalReo"] = "TRADITIONAL_REO";
    SellerConfigurationProgram["Usda"] = "USDA";
    SellerConfigurationProgram["Utm"] = "UTM";
})(SellerConfigurationProgram || (SellerConfigurationProgram = {}));
var SellerConfigurationRecipientRole;
(function (SellerConfigurationRecipientRole) {
    SellerConfigurationRecipientRole["Buyer"] = "BUYER";
    SellerConfigurationRecipientRole["BuyersAgent"] = "BUYERS_AGENT";
    SellerConfigurationRecipientRole["BuyersAgentBrokerCompany"] = "BUYERS_AGENT_BROKER_COMPANY";
    SellerConfigurationRecipientRole["BuyerClosingCompany"] = "BUYER_CLOSING_COMPANY";
    SellerConfigurationRecipientRole["CoBuyer"] = "CO_BUYER";
    SellerConfigurationRecipientRole["ListingAgent"] = "LISTING_AGENT";
    SellerConfigurationRecipientRole["Seller"] = "SELLER";
    SellerConfigurationRecipientRole["SellerClosingCompany"] = "SELLER_CLOSING_COMPANY";
})(SellerConfigurationRecipientRole || (SellerConfigurationRecipientRole = {}));
var SellerConfigurationRecipientType;
(function (SellerConfigurationRecipientType) {
    SellerConfigurationRecipientType["Cc"] = "CC";
    SellerConfigurationRecipientType["NotRequired"] = "NOT_REQUIRED";
    SellerConfigurationRecipientType["Signer"] = "SIGNER";
})(SellerConfigurationRecipientType || (SellerConfigurationRecipientType = {}));
var SellerConfigurationTitleInsuranceType;
(function (SellerConfigurationTitleInsuranceType) {
    SellerConfigurationTitleInsuranceType["BuyerToPay"] = "BUYER_TO_PAY";
    SellerConfigurationTitleInsuranceType["NotOffered"] = "NOT_OFFERED";
    SellerConfigurationTitleInsuranceType["ReferToPsa"] = "REFER_TO_PSA";
    SellerConfigurationTitleInsuranceType["SellerToPay"] = "SELLER_TO_PAY";
})(SellerConfigurationTitleInsuranceType || (SellerConfigurationTitleInsuranceType = {}));
var SellerIntentType;
(function (SellerIntentType) {
    SellerIntentType["Flexibility"] = "FLEXIBILITY";
    SellerIntentType["Speed"] = "SPEED";
    SellerIntentType["Value"] = "VALUE";
})(SellerIntentType || (SellerIntentType = {}));
var SellerPersonaType;
(function (SellerPersonaType) {
    SellerPersonaType["Novice"] = "NOVICE";
    SellerPersonaType["Seller"] = "SELLER";
    SellerPersonaType["TrustedSeller"] = "TRUSTED_SELLER";
})(SellerPersonaType || (SellerPersonaType = {}));
var SellerProductTypes;
(function (SellerProductTypes) {
    SellerProductTypes["Cwcot"] = "CWCOT";
    SellerProductTypes["Foreclosure"] = "FORECLOSURE";
    SellerProductTypes["NonReo"] = "NON_REO";
    SellerProductTypes["Reo"] = "REO";
    SellerProductTypes["ShortSale"] = "SHORT_SALE";
})(SellerProductTypes || (SellerProductTypes = {}));
var SellerSentiment;
(function (SellerSentiment) {
    SellerSentiment["Negative"] = "NEGATIVE";
    SellerSentiment["Neutral"] = "NEUTRAL";
    SellerSentiment["Positive"] = "POSITIVE";
})(SellerSentiment || (SellerSentiment = {}));
var SellerType;
(function (SellerType) {
    SellerType["Institutional"] = "INSTITUTIONAL";
    SellerType["NonInstitutional"] = "NON_INSTITUTIONAL";
})(SellerType || (SellerType = {}));
var SessionHandoffTarget;
(function (SessionHandoffTarget) {
    SessionHandoffTarget["Auctioncom"] = "AUCTIONCOM";
    SessionHandoffTarget["Smartsale"] = "SMARTSALE";
})(SessionHandoffTarget || (SessionHandoffTarget = {}));
var ShallowTaskWorkflowItemExpectation;
(function (ShallowTaskWorkflowItemExpectation) {
    ShallowTaskWorkflowItemExpectation["Encouraged"] = "ENCOURAGED";
    ShallowTaskWorkflowItemExpectation["Mandatory"] = "MANDATORY";
    ShallowTaskWorkflowItemExpectation["Optional"] = "OPTIONAL";
})(ShallowTaskWorkflowItemExpectation || (ShallowTaskWorkflowItemExpectation = {}));
var ShallowTaskWorkflowItemStatus;
(function (ShallowTaskWorkflowItemStatus) {
    ShallowTaskWorkflowItemStatus["Complete"] = "COMPLETE";
    ShallowTaskWorkflowItemStatus["Ongoing"] = "ONGOING";
    ShallowTaskWorkflowItemStatus["Upcoming"] = "UPCOMING";
})(ShallowTaskWorkflowItemStatus || (ShallowTaskWorkflowItemStatus = {}));
var SortConditionOrder;
(function (SortConditionOrder) {
    SortConditionOrder["Asc"] = "ASC";
    SortConditionOrder["Desc"] = "DESC";
})(SortConditionOrder || (SortConditionOrder = {}));
var StrategyType;
(function (StrategyType) {
    StrategyType["CurrencyAmount"] = "CURRENCY_AMOUNT";
    StrategyType["NotSet"] = "NOT_SET";
    StrategyType["Percentage"] = "PERCENTAGE";
})(StrategyType || (StrategyType = {}));
var SubjectToStatus;
(function (SubjectToStatus) {
    SubjectToStatus["Cancelled"] = "CANCELLED";
    SubjectToStatus["None"] = "NONE";
    SubjectToStatus["Others"] = "OTHERS";
    SubjectToStatus["Pending"] = "PENDING";
    SubjectToStatus["SellerAccepted"] = "SELLER_ACCEPTED";
    SubjectToStatus["SellerCounterOffered"] = "SELLER_COUNTER_OFFERED";
    SubjectToStatus["SellerRejected"] = "SELLER_REJECTED";
})(SubjectToStatus || (SubjectToStatus = {}));
var SupportedInvitationPartyRole;
(function (SupportedInvitationPartyRole) {
    SupportedInvitationPartyRole["ListingAgent"] = "LISTING_AGENT";
    SupportedInvitationPartyRole["PrivateSeller"] = "PRIVATE_SELLER";
})(SupportedInvitationPartyRole || (SupportedInvitationPartyRole = {}));
var SupportedLineOfBusiness;
(function (SupportedLineOfBusiness) {
    SupportedLineOfBusiness["Fcl"] = "FCL";
    SupportedLineOfBusiness["Pvt"] = "PVT";
    SupportedLineOfBusiness["Reo"] = "REO";
})(SupportedLineOfBusiness || (SupportedLineOfBusiness = {}));
var TenboxFileDescriptorStatus;
(function (TenboxFileDescriptorStatus) {
    TenboxFileDescriptorStatus["Deleted"] = "DELETED";
    TenboxFileDescriptorStatus["Failed"] = "FAILED";
    TenboxFileDescriptorStatus["Pending"] = "PENDING";
    TenboxFileDescriptorStatus["Purged"] = "PURGED";
    TenboxFileDescriptorStatus["Ready"] = "READY";
})(TenboxFileDescriptorStatus || (TenboxFileDescriptorStatus = {}));
var TimeSelection;
(function (TimeSelection) {
    TimeSelection["Event"] = "EVENT";
    TimeSelection["Venue"] = "VENUE";
})(TimeSelection || (TimeSelection = {}));
var TransactionContextAction;
(function (TransactionContextAction) {
    TransactionContextAction["AssignTheBidHold"] = "ASSIGN_THE_BID_HOLD";
    TransactionContextAction["AssignTheBidReturn"] = "ASSIGN_THE_BID_RETURN";
    TransactionContextAction["BiddingRegistration"] = "BIDDING_REGISTRATION";
    TransactionContextAction["ContractingAdjustment"] = "CONTRACTING_ADJUSTMENT";
    TransactionContextAction["CreditForCancellation"] = "CREDIT_FOR_CANCELLATION";
    TransactionContextAction["Fallout"] = "FALLOUT";
    TransactionContextAction["GeneralFunding"] = "GENERAL_FUNDING";
    TransactionContextAction["RemainingPaymentForClosing"] = "REMAINING_PAYMENT_FOR_CLOSING";
    TransactionContextAction["ReturnOfFunds"] = "RETURN_OF_FUNDS";
    TransactionContextAction["Sale"] = "SALE";
})(TransactionContextAction || (TransactionContextAction = {}));
var TransactionContextSource;
(function (TransactionContextSource) {
    TransactionContextSource["Listing"] = "LISTING";
    TransactionContextSource["LiveAuctionSegment"] = "LIVE_AUCTION_SEGMENT";
    TransactionContextSource["ManualWireTransfer"] = "MANUAL_WIRE_TRANSFER";
    TransactionContextSource["OnlineAuctionSegment"] = "ONLINE_AUCTION_SEGMENT";
})(TransactionContextSource || (TransactionContextSource = {}));
var TransactionLogReportType;
(function (TransactionLogReportType) {
    TransactionLogReportType["DisputedCardPayments"] = "DISPUTED_CARD_PAYMENTS";
    TransactionLogReportType["DisputedLiquidatedDamages"] = "DISPUTED_LIQUIDATED_DAMAGES";
    TransactionLogReportType["DisputedOtherPayments"] = "DISPUTED_OTHER_PAYMENTS";
    TransactionLogReportType["InProgressPayments"] = "IN_PROGRESS_PAYMENTS";
    TransactionLogReportType["InProgressRefunds"] = "IN_PROGRESS_REFUNDS";
    TransactionLogReportType["LiquidatedDamages"] = "LIQUIDATED_DAMAGES";
    TransactionLogReportType["SuccessfulPayments"] = "SUCCESSFUL_PAYMENTS";
    TransactionLogReportType["SuccessfulRefunds"] = "SUCCESSFUL_REFUNDS";
})(TransactionLogReportType || (TransactionLogReportType = {}));
var TransactionLogType;
(function (TransactionLogType) {
    TransactionLogType["Capture"] = "CAPTURE";
    TransactionLogType["Charge"] = "CHARGE";
    TransactionLogType["Dispute"] = "DISPUTE";
    TransactionLogType["Payment"] = "PAYMENT";
    TransactionLogType["Refund"] = "REFUND";
    TransactionLogType["Reversal"] = "REVERSAL";
})(TransactionLogType || (TransactionLogType = {}));
var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["Canceled"] = "CANCELED";
    TransactionStatus["Failed"] = "FAILED";
    TransactionStatus["Lost"] = "LOST";
    TransactionStatus["NeedsResponse"] = "NEEDS_RESPONSE";
    TransactionStatus["Pending"] = "PENDING";
    TransactionStatus["Processing"] = "PROCESSING";
    TransactionStatus["RequiresAction"] = "REQUIRES_ACTION";
    TransactionStatus["RequiresCapture"] = "REQUIRES_CAPTURE";
    TransactionStatus["RequiresConfirmation"] = "REQUIRES_CONFIRMATION";
    TransactionStatus["RequiresPaymentMethod"] = "REQUIRES_PAYMENT_METHOD";
    TransactionStatus["Succeeded"] = "SUCCEEDED";
    TransactionStatus["UnderReview"] = "UNDER_REVIEW";
    TransactionStatus["WarningClosed"] = "WARNING_CLOSED";
    TransactionStatus["WarningNeedsResponse"] = "WARNING_NEEDS_RESPONSE";
    TransactionStatus["WarningUnderReview"] = "WARNING_UNDER_REVIEW";
    TransactionStatus["Won"] = "WON";
})(TransactionStatus || (TransactionStatus = {}));
var TransactionType;
(function (TransactionType) {
    TransactionType["Credit"] = "CREDIT";
    TransactionType["Debit"] = "DEBIT";
    TransactionType["PendingCredit"] = "PENDING_CREDIT";
    TransactionType["PendingDebit"] = "PENDING_DEBIT";
    TransactionType["Void"] = "VOID";
})(TransactionType || (TransactionType = {}));
var TrinityCampaignModificationSource;
(function (TrinityCampaignModificationSource) {
    TrinityCampaignModificationSource["Auctionsync"] = "AUCTIONSYNC";
})(TrinityCampaignModificationSource || (TrinityCampaignModificationSource = {}));
var TrusteeContractAuditSourceType;
(function (TrusteeContractAuditSourceType) {
    TrusteeContractAuditSourceType["AuctionSync"] = "AUCTION_SYNC";
    TrusteeContractAuditSourceType["System"] = "SYSTEM";
    TrusteeContractAuditSourceType["TransactionManager"] = "TRANSACTION_MANAGER";
})(TrusteeContractAuditSourceType || (TrusteeContractAuditSourceType = {}));
var TrusteeContractAutomationStatus;
(function (TrusteeContractAutomationStatus) {
    TrusteeContractAutomationStatus["Failure"] = "FAILURE";
    TrusteeContractAutomationStatus["NotAttempted"] = "NOT_ATTEMPTED";
    TrusteeContractAutomationStatus["Successful"] = "SUCCESSFUL";
})(TrusteeContractAutomationStatus || (TrusteeContractAutomationStatus = {}));
var TrusteeContractCertificateType;
(function (TrusteeContractCertificateType) {
    TrusteeContractCertificateType["CertificateOfSales"] = "CERTIFICATE_OF_SALES";
    TrusteeContractCertificateType["ContractPackage"] = "CONTRACT_PACKAGE";
    TrusteeContractCertificateType["PostponementCertificate"] = "POSTPONEMENT_CERTIFICATE";
    TrusteeContractCertificateType["RevertCertificate"] = "REVERT_CERTIFICATE";
})(TrusteeContractCertificateType || (TrusteeContractCertificateType = {}));
var TrusteeContractCheckFileType;
(function (TrusteeContractCheckFileType) {
    TrusteeContractCheckFileType["Back"] = "BACK";
    TrusteeContractCheckFileType["Front"] = "FRONT";
})(TrusteeContractCheckFileType || (TrusteeContractCheckFileType = {}));
var TrusteeContractExpectedPaymentReason;
(function (TrusteeContractExpectedPaymentReason) {
    TrusteeContractExpectedPaymentReason["StateDeposit"] = "STATE_DEPOSIT";
})(TrusteeContractExpectedPaymentReason || (TrusteeContractExpectedPaymentReason = {}));
var TrusteeContractFileType;
(function (TrusteeContractFileType) {
    TrusteeContractFileType["BuyerSignature"] = "BUYER_SIGNATURE";
    TrusteeContractFileType["WitnessSignature"] = "WITNESS_SIGNATURE";
})(TrusteeContractFileType || (TrusteeContractFileType = {}));
var TrusteeContractFundType;
(function (TrusteeContractFundType) {
    TrusteeContractFundType["Cash"] = "CASH";
    TrusteeContractFundType["Check"] = "CHECK";
    TrusteeContractFundType["Finance"] = "FINANCE";
    TrusteeContractFundType["HardMoneyLoan"] = "HARD_MONEY_LOAN";
    TrusteeContractFundType["LineOfCredit"] = "LINE_OF_CREDIT";
    TrusteeContractFundType["Other"] = "OTHER";
    TrusteeContractFundType["Wire"] = "WIRE";
})(TrusteeContractFundType || (TrusteeContractFundType = {}));
var TrusteeContractNotificationType;
(function (TrusteeContractNotificationType) {
    TrusteeContractNotificationType["CertificateOfSale"] = "CERTIFICATE_OF_SALE";
})(TrusteeContractNotificationType || (TrusteeContractNotificationType = {}));
var TrusteeContractStatus;
(function (TrusteeContractStatus) {
    TrusteeContractStatus["Closed"] = "CLOSED";
    TrusteeContractStatus["Open"] = "OPEN";
})(TrusteeContractStatus || (TrusteeContractStatus = {}));
var TrusteeCustomerType;
(function (TrusteeCustomerType) {
    TrusteeCustomerType["Guest"] = "GUEST";
    TrusteeCustomerType["Owner"] = "OWNER";
    TrusteeCustomerType["Representative"] = "REPRESENTATIVE";
})(TrusteeCustomerType || (TrusteeCustomerType = {}));
var UserAuthorizationAction;
(function (UserAuthorizationAction) {
    UserAuthorizationAction["EditEmail"] = "EDIT_EMAIL";
})(UserAuthorizationAction || (UserAuthorizationAction = {}));
var UserDocumentPurpose;
(function (UserDocumentPurpose) {
    UserDocumentPurpose["BuyersAgentAgreement"] = "BUYERS_AGENT_AGREEMENT";
    UserDocumentPurpose["ProofOfFunds"] = "PROOF_OF_FUNDS";
})(UserDocumentPurpose || (UserDocumentPurpose = {}));
var UserListingAuthorizationAction;
(function (UserListingAuthorizationAction) {
    UserListingAuthorizationAction["OnlineBiddingRegistration"] = "ONLINE_BIDDING_REGISTRATION";
    UserListingAuthorizationAction["OnlineDirectOffer"] = "ONLINE_DIRECT_OFFER";
    UserListingAuthorizationAction["OnlineProxyBidding"] = "ONLINE_PROXY_BIDDING";
    UserListingAuthorizationAction["OnlineRegularBidding"] = "ONLINE_REGULAR_BIDDING";
})(UserListingAuthorizationAction || (UserListingAuthorizationAction = {}));
var UserStatus;
(function (UserStatus) {
    UserStatus["Confirmed"] = "CONFIRMED";
    UserStatus["Inactive"] = "INACTIVE";
    UserStatus["Pending"] = "PENDING";
    UserStatus["Suspended"] = "SUSPENDED";
})(UserStatus || (UserStatus = {}));
var UserType;
(function (UserType) {
    UserType["Agent"] = "AGENT";
    UserType["Nonagent"] = "NONAGENT";
})(UserType || (UserType = {}));
var VenueClassification;
(function (VenueClassification) {
    VenueClassification["TrusteeConversion"] = "TRUSTEE_CONVERSION";
    VenueClassification["TrusteeStandard"] = "TRUSTEE_STANDARD";
})(VenueClassification || (VenueClassification = {}));
var VenueEventType;
(function (VenueEventType) {
    VenueEventType["NonTrustee"] = "NON_TRUSTEE";
    VenueEventType["Trustee"] = "TRUSTEE";
})(VenueEventType || (VenueEventType = {}));
var VenueFileType;
(function (VenueFileType) {
    VenueFileType["GeneralAnnouncementRecording"] = "GENERAL_ANNOUNCEMENT_RECORDING";
})(VenueFileType || (VenueFileType = {}));
var VenueListingCountAggregationCategory;
(function (VenueListingCountAggregationCategory) {
    VenueListingCountAggregationCategory["Active"] = "ACTIVE";
    VenueListingCountAggregationCategory["Scheduled"] = "SCHEDULED";
})(VenueListingCountAggregationCategory || (VenueListingCountAggregationCategory = {}));
var VenueSetting;
(function (VenueSetting) {
    VenueSetting["Ballroom"] = "BALLROOM";
    VenueSetting["Courthouse"] = "COURTHOUSE";
    VenueSetting["Onlocation"] = "ONLOCATION";
})(VenueSetting || (VenueSetting = {}));
var VenueType;
(function (VenueType) {
    VenueType["Live"] = "LIVE";
    VenueType["Online"] = "ONLINE";
    VenueType["ThirdParty"] = "THIRD_PARTY";
})(VenueType || (VenueType = {}));
var VerificationStatus;
(function (VerificationStatus) {
    VerificationStatus["ApprovedManually"] = "APPROVED_MANUALLY";
    VerificationStatus["ApprovedVerified"] = "APPROVED_VERIFIED";
    VerificationStatus["NotVerified"] = "NOT_VERIFIED";
    VerificationStatus["RejectedDuplicate"] = "REJECTED_DUPLICATE";
    VerificationStatus["RejectedFraud"] = "REJECTED_FRAUD";
    VerificationStatus["RejectedManually"] = "REJECTED_MANUALLY";
    VerificationStatus["RejectedOther"] = "REJECTED_OTHER";
    VerificationStatus["VerificationInProgress"] = "VERIFICATION_IN_PROGRESS";
})(VerificationStatus || (VerificationStatus = {}));

var G = /*#__PURE__*/Object.freeze({
    __proto__: null,
    get ActionStatus () { return ActionStatus; },
    get AdcAssignedSigner () { return AdcAssignedSigner; },
    get AssetType () { return AssetType; },
    get AttorneyCompanyType () { return AttorneyCompanyType; },
    get AttorneyLeadStatus () { return AttorneyLeadStatus; },
    get AttributionSourceType () { return AttributionSourceType; },
    get AuctionSegmentStatus () { return AuctionSegmentStatus; },
    get AuctionStatus () { return AuctionStatus; },
    get AuctionType () { return AuctionType; },
    get BidSource () { return BidSource; },
    get BidType () { return BidType; },
    get BidderRegistrationSignupSource () { return BidderRegistrationSignupSource; },
    get BidderType () { return BidderType; },
    get BidderUserType () { return BidderUserType; },
    get BidderVerificationType () { return BidderVerificationType; },
    get BidsAwayStatus () { return BidsAwayStatus; },
    get BuyerPath () { return BuyerPath; },
    get BuyerPaymentType () { return BuyerPaymentType; },
    get CancelPrimaryReason () { return CancelPrimaryReason; },
    get CertificateQualityControlStatus () { return CertificateQualityControlStatus; },
    get CertificateType () { return CertificateType; },
    get ChargeReason () { return ChargeReason; },
    get ClosingCancellationReason () { return ClosingCancellationReason; },
    get ClosingOverviewProjectionGroupingKey () { return ClosingOverviewProjectionGroupingKey; },
    get ClosingRelationship () { return ClosingRelationship; },
    get CommissionPayerType () { return CommissionPayerType; },
    get CommissionStrategyType () { return CommissionStrategyType; },
    get CommunicationMethod () { return CommunicationMethod; },
    get ConsumerListingCompletionStatus () { return ConsumerListingCompletionStatus; },
    get ConsumerListingDocumentPurposeType () { return ConsumerListingDocumentPurposeType; },
    get ConsumerListingLienType () { return ConsumerListingLienType; },
    get ConsumerListingMoveOutPreference () { return ConsumerListingMoveOutPreference; },
    get ConsumerListingPartyRole () { return ConsumerListingPartyRole; },
    get ConsumerListingStatus () { return ConsumerListingStatus; },
    get CriedBy () { return CriedBy; },
    get CurrentTargetAudience () { return CurrentTargetAudience; },
    get CustomerType () { return CustomerType; },
    get DeedMailingAddressTo () { return DeedMailingAddressTo; },
    get DeviceStatus () { return DeviceStatus; },
    get DeviceTokenProvider () { return DeviceTokenProvider; },
    get DirectOfferActivityType () { return DirectOfferActivityType; },
    get DirectOfferBuyerAction () { return DirectOfferBuyerAction; },
    get DirectOfferCategory () { return DirectOfferCategory; },
    get DirectOfferEventAction () { return DirectOfferEventAction; },
    get DirectOfferStatus () { return DirectOfferStatus; },
    get DirectOfferType () { return DirectOfferType; },
    get DirectOfferUserType () { return DirectOfferUserType; },
    get DocumentExternalIdentifierType () { return DocumentExternalIdentifierType; },
    get DomainEventTypeName () { return DomainEventTypeName; },
    get Emd_Requirement () { return Emd_Requirement; },
    get EventType () { return EventType; },
    get ExternalBidderSourceType () { return ExternalBidderSourceType; },
    get ExternalSyncStatus () { return ExternalSyncStatus; },
    get ExternallySubmittedSalesResultType () { return ExternallySubmittedSalesResultType; },
    get FalloutCausedBy () { return FalloutCausedBy; },
    get FalloutReason () { return FalloutReason; },
    get FinanceTransactionStatus () { return FinanceTransactionStatus; },
    get FinanceType () { return FinanceType; },
    get FirstLookBuyerSelectionType () { return FirstLookBuyerSelectionType; },
    get FormattedAddressFormat () { return FormattedAddressFormat; },
    get FundModificationStatus () { return FundModificationStatus; },
    get FundReconciliationStatus () { return FundReconciliationStatus; },
    get FundStatus () { return FundStatus; },
    get FundTransactionType () { return FundTransactionType; },
    get GlobalMediaPriorityLevel () { return GlobalMediaPriorityLevel; },
    get GlobalMediaPurpose () { return GlobalMediaPurpose; },
    get GlobalMediaUsage () { return GlobalMediaUsage; },
    get IntacctTransactionStatus () { return IntacctTransactionStatus; },
    get IntakeMethodType () { return IntakeMethodType; },
    get InvitationFilterPartyRole () { return InvitationFilterPartyRole; },
    get InvitationIntent () { return InvitationIntent; },
    get InvitationRelativeType () { return InvitationRelativeType; },
    get InvitationStatus () { return InvitationStatus; },
    get LawCode () { return LawCode; },
    get LeadAuctionType () { return LeadAuctionType; },
    get LeadExceptionType () { return LeadExceptionType; },
    get LeadIntakeProgramType () { return LeadIntakeProgramType; },
    get LeadIntakeSyncStatus () { return LeadIntakeSyncStatus; },
    get LegalConstraintCode () { return LegalConstraintCode; },
    get ListingClosingResponsibilityType () { return ListingClosingResponsibilityType; },
    get ListingDeedType () { return ListingDeedType; },
    get ListingExternalIdentifierDataSource () { return ListingExternalIdentifierDataSource; },
    get ListingFinanceType () { return ListingFinanceType; },
    get ListingGroupType () { return ListingGroupType; },
    get ListingLandOwnershipType () { return ListingLandOwnershipType; },
    get ListingMoveOutPreference () { return ListingMoveOutPreference; },
    get ListingPaidBy () { return ListingPaidBy; },
    get ListingPartyRole () { return ListingPartyRole; },
    get ListingPendingUpdateStatus () { return ListingPendingUpdateStatus; },
    get ListingProductClassification () { return ListingProductClassification; },
    get ListingStatus () { return ListingStatus; },
    get ListingStatusGroup () { return ListingStatusGroup; },
    get ListingStatusLabelIntent () { return ListingStatusLabelIntent; },
    get ListingStrategyBidDepositStrategy () { return ListingStrategyBidDepositStrategy; },
    get ListingStrategyClosingMethodType () { return ListingStrategyClosingMethodType; },
    get ListingStrategyPricingStrategy () { return ListingStrategyPricingStrategy; },
    get ListingStrategySellingMethodType () { return ListingStrategySellingMethodType; },
    get ListingTermsEnforcement () { return ListingTermsEnforcement; },
    get ListingTitleInsurancePolicy () { return ListingTitleInsurancePolicy; },
    get LiveAuctionSegmentBidEndStatus () { return LiveAuctionSegmentBidEndStatus; },
    get LiveAuctionSegmentBidType () { return LiveAuctionSegmentBidType; },
    get LiveAuctionSegmentBiddingStatus () { return LiveAuctionSegmentBiddingStatus; },
    get LiveAuctionSegmentFileType () { return LiveAuctionSegmentFileType; },
    get LiveAuctionStaffAssignmentType () { return LiveAuctionStaffAssignmentType; },
    get LiveAuctionStaffRole () { return LiveAuctionStaffRole; },
    get MaritalStatus () { return MaritalStatus; },
    get MarketingAttributeClass () { return MarketingAttributeClass; },
    get MarketingAttributeType () { return MarketingAttributeType; },
    get MarketingAvailableStatus () { return MarketingAvailableStatus; },
    get MediaPurposeType () { return MediaPurposeType; },
    get MediaType () { return MediaType; },
    get MediaUsageTypeCode () { return MediaUsageTypeCode; },
    get MlhSyncStatus () { return MlhSyncStatus; },
    get MobileOperatingSystem () { return MobileOperatingSystem; },
    get NoteUpdateReason () { return NoteUpdateReason; },
    get NotificationCategoryCode () { return NotificationCategoryCode; },
    get NotificationChannelType () { return NotificationChannelType; },
    get NotificationIntentCode () { return NotificationIntentCode; },
    get OtpDeliveryMechanism () { return OtpDeliveryMechanism; },
    get ObjectChangeReviewStatus () { return ObjectChangeReviewStatus; },
    get OccupancyDescriptionType () { return OccupancyDescriptionType; },
    get OccupancyStatus () { return OccupancyStatus; },
    get OccupancyType () { return OccupancyType; },
    get OfferorType () { return OfferorType; },
    get OnlineAuctionPersonaType () { return OnlineAuctionPersonaType; },
    get OnlineAuctionSegmentBidRankingVisibilityLevel () { return OnlineAuctionSegmentBidRankingVisibilityLevel; },
    get OnlineAuctionSegmentBidType () { return OnlineAuctionSegmentBidType; },
    get OnlineAuctionSegmentBiddingStatus () { return OnlineAuctionSegmentBiddingStatus; },
    get OnlineAuctionSegmentStatus () { return OnlineAuctionSegmentStatus; },
    get OnlineAuctionSegmentType () { return OnlineAuctionSegmentType; },
    get OnlineAuctionSegmentUpdateSource () { return OnlineAuctionSegmentUpdateSource; },
    get OnlineBidDepositRefundBlockReason () { return OnlineBidDepositRefundBlockReason; },
    get OnlineBidDepositRefundConsequence () { return OnlineBidDepositRefundConsequence; },
    get OnlineBidHistoryEntryActionType () { return OnlineBidHistoryEntryActionType; },
    get OnlineRegistrationStatus () { return OnlineRegistrationStatus; },
    get OnlineSegmentExtensionReason () { return OnlineSegmentExtensionReason; },
    get OnlineSegmentExtensionType () { return OnlineSegmentExtensionType; },
    get Origin () { return Origin; },
    get PartyAuthorizationAction () { return PartyAuthorizationAction; },
    get PartyBiddingStatus () { return PartyBiddingStatus; },
    get PayableTo () { return PayableTo; },
    get PaymentFailureReason () { return PaymentFailureReason; },
    get PaymentMethodType () { return PaymentMethodType; },
    get PhoneType () { return PhoneType; },
    get PostponementPrimaryReason () { return PostponementPrimaryReason; },
    get PreAuctionOfferMinimumType () { return PreAuctionOfferMinimumType; },
    get PreAuctionStatus () { return PreAuctionStatus; },
    get ProductType () { return ProductType; },
    get PropertyCondition () { return PropertyCondition; },
    get PropertyDnaFieldIdentifiers () { return PropertyDnaFieldIdentifiers; },
    get PropertyDocumentPurposeType () { return PropertyDocumentPurposeType; },
    get PropertyDocumentUsageType () { return PropertyDocumentUsageType; },
    get PropertyPhotoTag () { return PropertyPhotoTag; },
    get PropertyStructureType () { return PropertyStructureType; },
    get PropertyStructureTypeGroup () { return PropertyStructureTypeGroup; },
    get PropertyValuationSource () { return PropertyValuationSource; },
    get PropertyValueDataSource () { return PropertyValueDataSource; },
    get RecordStatus () { return RecordStatus; },
    get RefundIntentStatus () { return RefundIntentStatus; },
    get RefundPayableTo () { return RefundPayableTo; },
    get RelationshipToProperty () { return RelationshipToProperty; },
    get RemarkPurpose () { return RemarkPurpose; },
    get ReoCancellationAdditionalDetails () { return ReoCancellationAdditionalDetails; },
    get ReoCancellationReason () { return ReoCancellationReason; },
    get ReoContractDocumentGenerationProcessCode () { return ReoContractDocumentGenerationProcessCode; },
    get ReoContractMediaFileType () { return ReoContractMediaFileType; },
    get ReoOfferBuyerOccupancyCode () { return ReoOfferBuyerOccupancyCode; },
    get ReoOfferCancellationServicerDecision () { return ReoOfferCancellationServicerDecision; },
    get ReoOfferCertifiedBuyerType () { return ReoOfferCertifiedBuyerType; },
    get ReoOfferDocumentRecipientType () { return ReoOfferDocumentRecipientType; },
    get ReoOfferExtensionAdditionalDetails () { return ReoOfferExtensionAdditionalDetails; },
    get ReoOfferExtensionReason () { return ReoOfferExtensionReason; },
    get ReoOfferExtensionServicerDecision () { return ReoOfferExtensionServicerDecision; },
    get ReoOfferLendingStatus () { return ReoOfferLendingStatus; },
    get ReoOfferOwningEntitySubType () { return ReoOfferOwningEntitySubType; },
    get ReoOfferOwningEntityType () { return ReoOfferOwningEntityType; },
    get ReoOfferPurchaseType () { return ReoOfferPurchaseType; },
    get ReoOfferRealEstateAgentType () { return ReoOfferRealEstateAgentType; },
    get ReoOfferStatus () { return ReoOfferStatus; },
    get ReoOfferVestingType () { return ReoOfferVestingType; },
    get RescissionReason () { return RescissionReason; },
    get ReserveStatus () { return ReserveStatus; },
    get ResolvePolicy () { return ResolvePolicy; },
    get ReviewableResourceStatus () { return ReviewableResourceStatus; },
    get SalesforceSubscriptionGroup () { return SalesforceSubscriptionGroup; },
    get SavedSearchSource () { return SavedSearchSource; },
    get ScheduleFailureReason () { return ScheduleFailureReason; },
    get ScheduleStatus () { return ScheduleStatus; },
    get SealedBidFieldFeedbackStatus () { return SealedBidFieldFeedbackStatus; },
    get SealedBidProposedTermFieldType () { return SealedBidProposedTermFieldType; },
    get SealedBidStatus () { return SealedBidStatus; },
    get SeekQueryType () { return SeekQueryType; },
    get SellerAction () { return SellerAction; },
    get SellerAssignedSigner () { return SellerAssignedSigner; },
    get SellerConfigurationDeedType () { return SellerConfigurationDeedType; },
    get SellerConfigurationLineOfBusiness () { return SellerConfigurationLineOfBusiness; },
    get SellerConfigurationPartyRole () { return SellerConfigurationPartyRole; },
    get SellerConfigurationPortfolio () { return SellerConfigurationPortfolio; },
    get SellerConfigurationProduct () { return SellerConfigurationProduct; },
    get SellerConfigurationProgram () { return SellerConfigurationProgram; },
    get SellerConfigurationRecipientRole () { return SellerConfigurationRecipientRole; },
    get SellerConfigurationRecipientType () { return SellerConfigurationRecipientType; },
    get SellerConfigurationTitleInsuranceType () { return SellerConfigurationTitleInsuranceType; },
    get SellerIntentType () { return SellerIntentType; },
    get SellerPersonaType () { return SellerPersonaType; },
    get SellerProductTypes () { return SellerProductTypes; },
    get SellerSentiment () { return SellerSentiment; },
    get SellerType () { return SellerType; },
    get SessionHandoffTarget () { return SessionHandoffTarget; },
    get ShallowTaskWorkflowItemExpectation () { return ShallowTaskWorkflowItemExpectation; },
    get ShallowTaskWorkflowItemStatus () { return ShallowTaskWorkflowItemStatus; },
    get SortConditionOrder () { return SortConditionOrder; },
    get StrategyType () { return StrategyType; },
    get SubjectToStatus () { return SubjectToStatus; },
    get SupportedInvitationPartyRole () { return SupportedInvitationPartyRole; },
    get SupportedLineOfBusiness () { return SupportedLineOfBusiness; },
    get TenboxFileDescriptorStatus () { return TenboxFileDescriptorStatus; },
    get TimeSelection () { return TimeSelection; },
    get TransactionContextAction () { return TransactionContextAction; },
    get TransactionContextSource () { return TransactionContextSource; },
    get TransactionLogReportType () { return TransactionLogReportType; },
    get TransactionLogType () { return TransactionLogType; },
    get TransactionStatus () { return TransactionStatus; },
    get TransactionType () { return TransactionType; },
    get TrinityCampaignModificationSource () { return TrinityCampaignModificationSource; },
    get TrusteeContractAuditSourceType () { return TrusteeContractAuditSourceType; },
    get TrusteeContractAutomationStatus () { return TrusteeContractAutomationStatus; },
    get TrusteeContractCertificateType () { return TrusteeContractCertificateType; },
    get TrusteeContractCheckFileType () { return TrusteeContractCheckFileType; },
    get TrusteeContractExpectedPaymentReason () { return TrusteeContractExpectedPaymentReason; },
    get TrusteeContractFileType () { return TrusteeContractFileType; },
    get TrusteeContractFundType () { return TrusteeContractFundType; },
    get TrusteeContractNotificationType () { return TrusteeContractNotificationType; },
    get TrusteeContractStatus () { return TrusteeContractStatus; },
    get TrusteeCustomerType () { return TrusteeCustomerType; },
    get UserAuthorizationAction () { return UserAuthorizationAction; },
    get UserDocumentPurpose () { return UserDocumentPurpose; },
    get UserListingAuthorizationAction () { return UserListingAuthorizationAction; },
    get UserStatus () { return UserStatus; },
    get UserType () { return UserType; },
    get VenueClassification () { return VenueClassification; },
    get VenueEventType () { return VenueEventType; },
    get VenueFileType () { return VenueFileType; },
    get VenueListingCountAggregationCategory () { return VenueListingCountAggregationCategory; },
    get VenueSetting () { return VenueSetting; },
    get VenueType () { return VenueType; },
    get VerificationStatus () { return VerificationStatus; }
});

const gql = String.raw;
const enums = G;
const WELL_KNOWN_ALIAS_PREFIX = '_alias_';
const WELL_KNOWN_ALIAS_DELIMITER = '__';
const normalizeAliases = (node) => {
    if (Array.isArray(node)) {
        return node.map(item => normalizeAliases(item));
    }
    else if (typeof node === 'object' && node !== null) {
        return Object.entries(node).reduce((normalized, [key, value]) => {
            const normalizedKey = key.startsWith(WELL_KNOWN_ALIAS_PREFIX)
                ? key.split(WELL_KNOWN_ALIAS_DELIMITER).pop() || key
                : key;
            normalized[normalizedKey] = normalizeAliases(value);
            return normalized;
        }, {});
    }
    return node;
};
const utils = {
    normalizeAliases
};

export { G, enums, gql, utils };
//# sourceMappingURL=index.js.map
